import { useState, useRef, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";

// --- CONFIG -------------------------------------------------------------------
const CONFIG = {
 SUPABASE_URL: "https://gykslhwxpmtqjfnfacrk.supabase.co",
 SUPABASE_ANON_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd5a3NsaHd4cG10cWpmbmZhY3JrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIxNjYxNDYsImV4cCI6MjA4Nzc0MjE0Nn0.WLoX8ROg__Em9nJlLbb4pKNr-r46OXrDiM649Dbb-38",
};

// --- BOSS LOGINS --------------------------------------------------------------
const BOSSES = [
 { username: "jennifer", password: "jennifer2025", name: "Jennifer Mulchandani", role: "Director", avatar: "JM" },
 { username: "jay", password: "jay2025", name: "Jay Bhanushali", role: "Co-Founder", avatar: "JB" },
 { username: "raj", password: "raj2025", name: "Raj Bhanushali", role: "Co-Founder", avatar: "RB" },
];
const HR_PASSWORD = "acture2025";

// --- ACTURE MEDIA BRAND COLORS (Light Theme) --------------------------------
const C = {
 bg: "#F0F4FA",
 deep: "#E4ECF7",
 surface: "#EAF0F9",
 card: "#FFFFFF",
 border: "#C8D8EE",
 accent: "#1B2A6B",
 navy: "#1B2A6B",
 gold: "#D4880A",
 cyan: "#1565C0",
 purple: "#3B52B4",
 green: "#1B7A4E",
 red: "#C0392B",
 pink: "#9B3B8A",
 text: "#0D1B3E",
 sub: "#2A4A8A",
 muted: "#6B85B0",
};

// --- CONSTANTS ----------------------------------------------------------------
const DEPTS = [
 "Social Media","Client Servicing","Copywriter","Strategist",
 "Developer - Web/WordPress","UI/UX","SEO","Graphic Designer",
 "Video Editor","Lead Generation","Performance Marketing",
 "Business Development","AI & Data Specialist","HR"
];
const LEVELS = ["Intern","Associate","Executive","Senior","Manager"];
const STATUSES = ["Applied","Screening","Round 1","Round 2","Offered","Hired","Rejected","Hold"];
const STATUS_COLOR = {
 Applied:"#3B82F6", Screening:"#F59E0B", "Round 1":"#8B5CF6",
 "Round 2":"#EC4899", Offered:"#34D399", Hired:"#059669", Rejected:"#F87171", Hold:"#6B7280"
};
const EMP_TYPES = ["Full-time","Part-time","Contract","Intern","Freelance"];
const TRIGGERS = ["Replacement Hiring","New Role Creation","Capacity/Scale Hiring","Skill Gap Hiring","Intern/Trainee Pipeline","Project-Based Hiring"];
const ROUNDS = ["Round 1 – Functional","Round 2 – Culture & Alignment","HR Screening Call","Technical Test","Final"];

// --- SUPABASE -----------------------------------------------------------------
const db = {
 ready: () => CONFIG.SUPABASE_URL !== "YOUR_SUPABASE_URL",
 headers: () => ({
 "Content-Type": "application/json",
 "apikey": CONFIG.SUPABASE_ANON_KEY,
 "Authorization": "Bearer " + CONFIG.SUPABASE_ANON_KEY,
 "Prefer": "return=representation",
 }),
 async getAll(table) {
 if (!this.ready()) return [];
 try {
 const r = await fetch(CONFIG.SUPABASE_URL + "/rest/v1/" + table + "?select=*&order=created_at.desc", { headers: this.headers() });
 if (!r.ok) return [];
 const rows = await r.json();
 return rows.map(row => ({ ...row.data, _id: row.id }));
 } catch { return []; }
 },
 async upsert(table, id, data) {
 if (!this.ready()) return;
 try {
 await fetch(CONFIG.SUPABASE_URL + "/rest/v1/" + table + "?on_conflict=id", {
 method: "POST", headers: this.headers(),
 body: JSON.stringify({ id, data, created_at: new Date().toISOString() }),
 });
 } catch {}
 },
 async remove(table, id) {
 if (!this.ready()) return;
 try {
 await fetch(CONFIG.SUPABASE_URL + "/rest/v1/" + table + "?id=eq." + id, { method: "DELETE", headers: this.headers() });
 } catch {}
 },
};

const local = {
 async get(key) { try { const d = localStorage.getItem(key); return d ? JSON.parse(d) : []; } catch { return []; } },
 async set(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch {} },
};

async function dbGetAll(table, localKey) {
 if (db.ready()) return db.getAll(table);
 return local.get(localKey);
}
async function dbSave(table, localKey, id, item, allItems) {
 if (db.ready()) db.upsert(table, id, item);
 else local.set(localKey, allItems);
}
async function dbDelete(table, localKey, id, remaining) {
 if (db.ready()) db.remove(table, id);
 else local.set(localKey, remaining);
}

// --- PARSE STEPS --------------------------------------------------------------
const PARSE_STEPS = [
 " Reading document...",
 " Extracting raw text...",
 " AI entity recognition...",
 " Classifying skills...",
 " Indexed successfully!",
];

async function readFile(file) {
 return new Promise((resolve, reject) => {
 const reader = new FileReader();
 const ext = file.name.split(".").pop().toLowerCase();
 if (ext === "pdf") {
 reader.onload = () => resolve({ type: "pdf", data: reader.result.split(",")[1] });
 reader.onerror = reject;
 reader.readAsDataURL(file);
 } else {
 reader.onload = () => resolve({ type: "text", data: reader.result });
 reader.onerror = reject;
 reader.readAsText(file);
 }
 });
}

const RESUME_SYSTEM = `You are Acture Media's AI Resume Parsing Engine for a growth marketing agency.
Extract all information from the resume and return ONLY a valid JSON object. No markdown, no code fences, no explanation. Just raw JSON.

Schema:
{
 "name": "Full Name",
 "email": "email or empty string",
 "phone": "phone number or empty string",
 "location": "City, Country or empty string",
 "linkedin": "url or empty string",
 "portfolio": "url or empty string",
 "currentTitle": "Most recent job title",
 "currentCompany": "Most recent company name",
 "previousCompanies": ["Previous Co 1"],
 "totalYearsExp": 4,
 "seniority": "Intern or Associate or Executive or Senior or Manager",
 "departments": ["Social Media"],
 "skills": ["SEO", "Google Ads"],
 "tools": ["Ahrefs", "GA4"],
 "noticePeriod": "30 days or Immediate or Not mentioned",
 "expectedCTC": "expected CTC or empty string",
 "summary": "2-sentence professional summary",
 "scoring": {
 "skillMatchScore": 30,
 "experienceRelevance": 15,
 "toolExpertise": 12,
 "seniorityMatch": 8,
 "industryMatch": 7,
 "stabilityScore": 3
 },
 "strengths": ["strength 1", "strength 2"],
 "risks": ["risk 1"],
 "fitReason": "One sentence on why they fit or dont"
}

Departments (pick relevant): Social Media, Client Servicing, Copywriter, Strategist, Developer - Web/WordPress, UI/UX, SEO, Graphic Designer, Video Editor, Lead Generation, Performance Marketing, Business Development, AI & Data Specialist, HR
Seniority: Intern, Associate, Executive, Senior, Manager
Scoring: skillMatchScore 0-40, experienceRelevance 0-20, toolExpertise 0-15, seniorityMatch 0-10, industryMatch 0-10, stabilityScore 0-5`;

async function callClaudeAPI(payload) {
 const response = await fetch("http://localhost:3001/api/claude", {
 method: "POST",
 headers: { "Content-Type": "application/json" },
 body: JSON.stringify(payload),
 });
 if (!response.ok) {
 const errText = await response.text();
 throw new Error(errText);
 }
 return response;
}

async function callClaude(messages, system) {
 const response = await callClaudeAPI({
 model: "claude-haiku-4-5-20251001",
 max_tokens: 1200,
 system: system || "You are an expert HR AI for Acture Media.",
 messages,
 });
 const data = await response.json();
 return data.content?.[0]?.text || "";
}

async function callClaudeStream(messages, system, onChunk) {
 const response = await callClaudeAPI({
 model: "claude-haiku-4-5-20251001",
 max_tokens: 1500,
 stream: true,
 system: system || "You are an expert HR AI for Acture Media.",
 messages,
 });
 const reader = response.body.getReader();
 const decoder = new TextDecoder();
 let full = "";
 while (true) {
 const { done, value } = await reader.read();
 if (done) break;
 const chunk = decoder.decode(value, { stream: true });
 for (const line of chunk.split("\n")) {
 if (!line.startsWith("data: ")) continue;
 const data = line.slice(6).trim();
 if (data === "[DONE]") continue;
 try {
 const j = JSON.parse(data);
 const text = j.delta?.text || j.content_block?.text || "";
 if (text) { full += text; onChunk && onChunk(full); }
 } catch {}
 }
 }
 return full;
}

async function parseResume(fileData) {
 let messages;
 if (fileData.type === "pdf") {
 messages = [{
 role: "user",
 content: [
 { type: "document", source: { type: "base64", media_type: "application/pdf", data: fileData.data } },
 { type: "text", text: "Parse this resume. Return JSON only, following the schema in your system prompt exactly." },
 ],
 }];
 } else {
 messages = [{ role: "user", content: `Parse this resume. Return JSON only.\n\nRESUME:\n${fileData.data.substring(0, 8000)}` }];
 }
 const response = await callClaudeAPI({
 model: "claude-sonnet-4-20250514",
 max_tokens: 1800,
 system: RESUME_SYSTEM,
 messages,
 });
 const data = await response.json();
 const raw = data.content?.[0]?.text || "";
 return safeJSONParse(raw);
}

// --- JD-BASED FIT SCORING -----------------------------------------------------
async function calcJDFitScore(candidate, jd) {
 if (!jd || !jd.content) return null;
 try {
 const prompt = `You are an expert HR evaluator at Acture Media, a digital growth marketing agency.

JOB DESCRIPTION:
Title: ${jd.title}
Department: ${jd.department}
Experience Required: ${jd.experience || "Not specified"}
${jd.content.substring(0, 2500)}

CANDIDATE PROFILE:
Name: ${candidate.name}
Current Title: ${candidate.currentTitle}
Experience: ${candidate.totalYearsExp} years
Seniority Level: ${candidate.seniority}
Departments: ${(candidate.departments || []).join(", ")}
Skills: ${(candidate.skills || []).join(", ")}
Tools: ${(candidate.tools || []).join(", ")}
Summary: ${candidate.summary || ""}

Score this candidate against the job description from 0–100.
Evaluate:
- Skill alignment with JD requirements (40 points)
- Experience relevance and years (20 points)
- Tools/platform match (15 points)
- Seniority fit for the role (10 points)
- Industry/domain match (10 points)
- Stability/work history (5 points)

Return ONLY raw JSON, no markdown:
{"score": 72, "breakdown": {"skills": 28, "experience": 14, "tools": 10, "seniority": 8, "industry": 8, "stability": 4}, "reason": "One concise sentence explaining the fit"}`;

 const raw = await callClaude([{ role: "user", content: prompt }],
 "You are a JSON-only HR scoring evaluator. Return only raw JSON, no markdown fences.");
 const cleaned = raw.replace(/```json\s*/gi,"").replace(/```\s*/g,"").trim();
 const obj = JSON.parse(cleaned.substring(cleaned.indexOf("{"), cleaned.lastIndexOf("}")+1));
 return {
 score: Math.min(100, Math.max(0, Number(obj.score) || 0)),
 breakdown: obj.breakdown || {},
 reason: obj.reason || "",
 };
 } catch { return null; }
}

async function generateJD(role, dept, exp, skills, tone, onChunk) {
 return callClaudeStream([{
 role: "user",
 content: `Write a complete Job Description for Acture Media.
Role: ${role}
Department: ${dept}
Experience: ${exp}
Key Skills: ${skills}
Tone: ${tone}
Include: Role Overview, Key Responsibilities (8-10 points), Requirements (6-8 points), Tools & Platforms, What We Offer, About Acture Media (digital growth marketing agency, Mumbai).
Return plain text only.`,
 }], null, onChunk);
}

function safeJSONParse(raw) {
 if (!raw) return null;
 try {
 let cleaned = raw.replace(/```json\s*/gi, "").replace(/```\s*/g, "").trim();
 const start = cleaned.indexOf("{");
 const end = cleaned.lastIndexOf("}");
 if (start !== -1 && end !== -1) cleaned = cleaned.substring(start, end + 1);
 return JSON.parse(cleaned);
 } catch (e) { return null; }
}

function calcScore(s) {
 if (!s) return 0;
 return (s.skillMatchScore || s.skillMatch || 0) +
 (s.experienceRelevance || s.expRelevance || 0) +
 (s.toolExpertise || s.toolDepth || 0) +
 (s.seniorityMatch || 0) + (s.industryMatch || 0) + (s.stabilityScore || 0);
}

function getDisplayScore(c) {
 if (c.jdFitScore != null) return c.jdFitScore;
 return calcScore(c.scoring);
}

function uid() { return Date.now() + "_" + Math.random().toString(36).slice(2, 7); }

function downloadPDF(jd) {
 const w = window.open("", "_blank");
 w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${jd.title} – JD</title>
 <style>body{font-family:Arial,sans-serif;max-width:800px;margin:40px auto;padding:0 20px;color:#1a1a1a;line-height:1.7}h1{color:#1B2A6B;border-bottom:3px solid #5BA3D9;padding-bottom:12px}.meta{background:#f0f4ff;padding:14px 18px;border-radius:8px;margin:18px 0;display:flex;gap:24px;flex-wrap:wrap;font-size:13px}@media print{body{margin:20px}}</style>
 </head><body><h1>${jd.title}</h1>
 <div class="meta"><span><strong>Department:</strong> ${jd.department}</span><span><strong>Experience:</strong> ${jd.experience||"Open"}</span><span><strong>Type:</strong> ${jd.employmentType||"Full-time"}</span><span><strong>CTC:</strong> ${jd.ctcRange||"Competitive"}</span></div>
 <div style="white-space:pre-wrap;font-size:14px;line-height:1.8">${jd.content}</div>
 </body></html>`);
 w.document.close(); setTimeout(() => w.print(), 600);
}

function downloadDOC(jd) {
 const safe = jd.content.replace(/[{}\\]/g, "\\$&").replace(/\n/g, "\\par\n");
 const rtf = `{\\rtf1\\ansi\\deff0{\\fonttbl{\\f0 Arial;}}{\\colortbl;\\red27\\green42\\blue107;}\\f0\\fs24{\\b\\fs36\\cf1 ${jd.title}\\par}\\par{\\b Department:} ${jd.department}\\par\\par${safe}}`;
 const blob = new Blob([rtf], { type: "application/rtf" });
 const url = URL.createObjectURL(blob);
 const a = document.createElement("a"); a.href = url; a.download = jd.title.replace(/\s+/g,"-")+"_JD.doc"; a.click();
 URL.revokeObjectURL(url);
}

// --- UI PRIMITIVES ------------------------------------------------------------
function ScoreBadge({ score, jdBased }) {
 return (
 <div style={{ display:"inline-flex", alignItems:"center", gap:5, background:C.accent+"18", border:"1px solid "+C.accent+"40", borderRadius:8, padding:"3px 10px", fontSize:13, fontWeight:700, color:C.accent }}>
 {score}/100
 {jdBased && <span style={{fontSize:9,opacity:0.75,background:C.accent+"30",borderRadius:3,padding:"1px 4px"}}>JD</span>}
 </div>
 );
}

function StatusPill({ status }) {
 return <span style={{ background:C.accent+"18", color:C.accent, border:"1px solid "+C.accent+"35", borderRadius:6, padding:"2px 8px", fontSize:11, fontWeight:600 }}>{status}</span>;
}

function Tag({ label, color = C.accent }) {
 return <span style={{ background:color+"18", color, border:"1px solid "+color+"35", borderRadius:5, padding:"2px 7px", fontSize:11, fontWeight:500 }}>{label}</span>;
}

function Input({ label, value, onChange, placeholder, type="text", required }) {
 return (
 <div>
 {label && <div style={{fontSize:13,color:C.muted,marginBottom:6}}>{label}{required&&<span style={{color:C.accent}}> *</span>}</div>}
 <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
 style={{width:"100%",background:C.surface,border:"1px solid "+C.border,borderRadius:8,padding:"11px 14px",color:C.text,fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"'Poppins', sans-serif"}}/>
 </div>
 );
}

function Select({ label, value, onChange, options, required }) {
 return (
 <div>
 {label && <div style={{fontSize:13,color:C.muted,marginBottom:6}}>{label}{required&&<span style={{color:C.accent}}> *</span>}</div>}
 <select value={value} onChange={e=>onChange(e.target.value)}
 style={{width:"100%",background:C.surface,color:value?C.text:C.muted,border:"1px solid "+C.border,borderRadius:8,padding:"11px 14px",fontSize:14,boxSizing:"border-box",fontFamily:"'Poppins', sans-serif"}}>
 <option value="">Select...</option>
 {options.map(o=><option key={o} value={o}>{o}</option>)}
 </select>
 </div>
 );
}

function Textarea({ label, value, onChange, placeholder, rows=4 }) {
 return (
 <div>
 {label && <div style={{fontSize:13,color:C.muted,marginBottom:6}}>{label}</div>}
 <textarea value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} rows={rows}
 style={{width:"100%",background:C.surface,border:"1px solid "+C.border,borderRadius:8,padding:"11px 14px",color:C.text,fontSize:14,outline:"none",resize:"vertical",fontFamily:"'Poppins', sans-serif",boxSizing:"border-box"}}/>
 </div>
 );
}

const VARIANT_STYLES = {
 primary: { background:C.accent, color:"#fff", border:"none" },
 secondary: { background:C.surface, color:C.sub, border:"1px solid "+C.border },
 success: { background:C.green+"20", color:C.green, border:"1px solid "+C.green+"40" },
 danger: { background:C.red+"15", color:C.red, border:"1px solid "+C.red+"40" },
 ghost: { background:"transparent", color:C.muted, border:"1px solid "+C.border },
 purple: { background:C.purple+"20", color:C.purple, border:"1px solid "+C.purple+"40" },
 accent: { background:C.accent+"20", color:C.accent, border:"1px solid "+C.accent+"40" },
};

function Btn({ children, onClick, variant="primary", disabled=false, small=false, style:sx={} }) {
 return (
 <button onClick={onClick} disabled={disabled}
 style={{...VARIANT_STYLES[variant]||VARIANT_STYLES.primary,borderRadius:8,padding:small?"7px 14px":"11px 22px",fontSize:small?12:14,fontWeight:600,cursor:disabled?"not-allowed":"pointer",opacity:disabled?0.5:1,transition:"all 0.15s",fontFamily:"'Poppins', sans-serif",...sx}}>
 {children}
 </button>
 );
}

function Toast({ msg, type, onClose }) {
 useEffect(()=>{ const t=setTimeout(onClose,4500); return()=>clearTimeout(t); },[]);
 const col = type==="success"?C.green:type==="error"?C.red:C.gold;
 return (
 <div style={{position:"fixed",bottom:24,right:24,zIndex:9999,background:C.card,border:"1px solid "+col+"50",borderLeft:"4px solid "+col,borderRadius:12,padding:"14px 20px",minWidth:300,maxWidth:420,boxShadow:"0 8px 32px rgba(0,0,0,0.6)",display:"flex",alignItems:"center",gap:12}}>
 <div style={{flex:1,fontSize:13,color:C.text,lineHeight:1.4}}>{msg}</div>
 <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:18}}></button>
 </div>
 );
}

function ParsingUI({ fileName, stepIndex }) {
 return (
 <div style={{background:C.card,border:"1px solid "+C.accent+"40",borderRadius:16,padding:"2rem"}}>
 <div style={{textAlign:"center",marginBottom:"1.5rem"}}>
 <div style={{fontSize:"2.5rem",marginBottom:"0.5rem"}}></div>
 <div style={{color:C.accent,fontSize:11,fontFamily:"monospace",letterSpacing:"1px",textTransform:"uppercase"}}>AI Parsing Engine</div>
 <div style={{color:C.muted,fontSize:11,marginTop:4,fontFamily:"monospace"}}>{fileName}</div>
 </div>
 {PARSE_STEPS.map((s,i)=>(
 <div key={i} style={{display:"flex",alignItems:"center",gap:"0.6rem",marginBottom:"0.5rem",fontSize:12,fontFamily:"monospace",color:i<stepIndex?C.green:i===stepIndex?C.accent:C.border,transition:"color 0.3s"}}>
 <span style={{width:14,flexShrink:0}}>{i<stepIndex?"":i===stepIndex?"":"·"}</span>
 <span>{s}</span>
 </div>
 ))}
 <div style={{marginTop:"1.25rem",background:C.surface,borderRadius:100,height:5,overflow:"hidden"}}>
 <div style={{background:C.accent,height:"100%",borderRadius:100,width:`${(stepIndex/(PARSE_STEPS.length-1))*100}%`,transition:"width 0.4s ease"}}/>
 </div>
 </div>
 );
}

// --- ACTURE LOGO --------------------------------------------------------------
function ActureLogo({ size = 40 }) {
 return (
 <img
 src="/actureLogo.png"
 alt="Acture Media"
 width={size}
 height={size}
 style={{ objectFit: "contain", display: "block", borderRadius: 8 }}
 />
 );
}

// ===============================================================================
// --- CANDIDATE PORTAL (PUBLIC) ------------------------------------------------
// ===============================================================================
function CandidatePortal() {
 const [dragging, setDragging] = useState(false);
 const [parsing, setParsing] = useState(false);
 const [stepIndex, setStepIndex] = useState(0);
 const [errorDetail, setErrorDetail] = useState("");
 const [submitted, setSubmitted] = useState(false);
 const [candidateName, setCandidateName] = useState("");
 const [manualText, setManualText] = useState("");
 const [useManual, setUseManual] = useState(false);
 const [fileName, setFileName] = useState("");
 const [selectedJDId, setSelectedJDId] = useState("");
 const [openJDs, setOpenJDs] = useState([]);
 const fileRef = useRef();

 useEffect(() => {
 dbGetAll("jd_documents", "acture_jds").then(docs => setOpenJDs(docs || []));
 }, []);

 const tick = (n) => new Promise(r => setTimeout(() => { setStepIndex(n); r(); }, 420));

 async function finishAndSave(parsed) {
 if (!parsed) { setParsing(false); setErrorDetail("Could not read your resume. Please try the 'Paste Resume Text' option below."); return; }
 const sc = parsed.scoring || {};
 const candidate = {
 id: uid(), uploadedAt: new Date().toISOString(), status: "Applied",
 fileName, source: "Candidate Portal",
 selectedJDId: selectedJDId || "",
 appliedRole: "", appliedDept: "",
 jdFitScore: null, jdFitReason: "",
 name: parsed.name || "Applicant",
 email: parsed.email || "", phone: parsed.phone || "", location: parsed.location || "",
 linkedin: parsed.linkedin || "", portfolio: parsed.portfolio || "",
 currentTitle: parsed.currentTitle || "N/A", currentCompany: parsed.currentCompany || "N/A",
 previousCompanies: Array.isArray(parsed.previousCompanies) ? parsed.previousCompanies : [],
 totalYearsExp: Number(parsed.totalYearsExp) || 0,
 seniority: parsed.seniority || "Associate",
 departments: Array.isArray(parsed.departments) && parsed.departments.length ? parsed.departments : ["General"],
 skills: Array.isArray(parsed.skills) ? parsed.skills : [],
 tools: Array.isArray(parsed.tools) ? parsed.tools : [],
 noticePeriod: parsed.noticePeriod || "Not mentioned",
 expectedCTC: parsed.expectedCTC || "",
 summary: parsed.summary || "",
 strengths: Array.isArray(parsed.strengths) ? parsed.strengths : [],
 risks: Array.isArray(parsed.risks) ? parsed.risks : [],
 fitReason: parsed.fitReason || "",
 scoring: {
 skillMatchScore: Number(sc.skillMatchScore || sc.skillMatch) || 20,
 experienceRelevance: Number(sc.experienceRelevance || sc.expRelevance) || 10,
 toolExpertise: Number(sc.toolExpertise || sc.toolDepth) || 8,
 seniorityMatch: Number(sc.seniorityMatch) || 5,
 industryMatch: Number(sc.industryMatch) || 5,
 stabilityScore: Number(sc.stabilityScore) || 2,
 },
 };

 const selectedJD = openJDs.find(j => j.id === selectedJDId);
 if (selectedJD) {
 candidate.appliedRole = selectedJD.title;
 candidate.appliedDept = selectedJD.department;
 const jdResult = await calcJDFitScore(candidate, selectedJD);
 if (jdResult) { candidate.jdFitScore = jdResult.score; candidate.jdFitReason = jdResult.reason; }
 }

 const all = await dbGetAll("candidates", "acture_candidates");
 await dbSave("candidates", "acture_candidates", candidate.id, candidate, [...all, candidate]);
 await tick(6);
 await new Promise(r => setTimeout(r, 500));
 setParsing(false); setCandidateName(candidate.name); setSubmitted(true);
 }

 async function processFile(file) {
 if (!file) return;
 const ext = file.name.split(".").pop().toLowerCase();
 if (!["pdf","doc","docx","txt"].includes(ext)) { setErrorDetail("Only PDF, DOC, DOCX, TXT supported."); return; }
 setErrorDetail(""); setFileName(file.name); setParsing(true); setStepIndex(0);
 try {
 await tick(1); const fileData = await readFile(file);
 await tick(2); await tick(3); await tick(4); await tick(5);
 await finishAndSave(await parseResume(fileData));
 } catch (err) { setParsing(false); setErrorDetail("Upload failed: " + err.message); }
 }

 async function processText(text) {
 setErrorDetail(""); setFileName("pasted-resume.txt"); setParsing(true); setStepIndex(0);
 try {
 await tick(1); await tick(2); await tick(3); await tick(4); await tick(5);
 await finishAndSave(await parseResume({ type: "text", data: text }));
 } catch (err) { setParsing(false); setErrorDetail("Upload failed: " + err.message); }
 }

 const onDrop = useCallback((e) => { e.preventDefault(); setDragging(false); processFile(e.dataTransfer.files[0]); }, [selectedJDId, openJDs]);

 if (submitted) return (
 <div style={{ minHeight:"100vh", background:C.bg, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
 <div style={{ maxWidth:520, width:"100%", textAlign:"center" }}>
 <div style={{ fontSize:72, marginBottom:24 }}></div>
 <div style={{ fontSize:32, fontWeight:800, color:C.text, marginBottom:12 }}>Application Received!</div>
 <div style={{ fontSize:17, color:C.sub, marginBottom:32, lineHeight:1.7 }}>
 Thank you <span style={{color:C.accent,fontWeight:700}}>{candidateName}</span>! Your resume has been submitted to Acture Media's talent pool. Our HR team will review your profile and reach out if there's a match.
 </div>
 <button onClick={() => { setSubmitted(false); setManualText(""); setFileName(""); setSelectedJDId(""); setErrorDetail(""); }}
 style={{ background:C.accent, color:"#fff", border:"none", borderRadius:12, padding:"14px 36px", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"'Poppins', sans-serif" }}>
 Submit Another Application
 </button>
 </div>
 </div>
 );

 if (parsing) return (
 <div style={{ minHeight:"100vh", background:C.bg, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
 <div style={{ maxWidth:520, width:"100%" }}>
 <div style={{ textAlign:"center", marginBottom:24 }}>
 <div style={{ fontSize:14, color:C.muted }}>Acture Media · Talent Acquisition</div>
 </div>
 <ParsingUI fileName={fileName} stepIndex={stepIndex} />
 </div>
 </div>
 );

 return (
 // *** CHANGE 1: fontFamily updated to Poppins ***
 <div style={{ minHeight:"100vh", background:C.bg, fontFamily:"'Poppins', sans-serif" }}>
 <style>{`
 @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');
 *{box-sizing:border-box;}
 ::-webkit-scrollbar{width:6px;}
 ::-webkit-scrollbar-track{background:#F0F4FA;}
 ::-webkit-scrollbar-thumb{background:#C8D8EE;border-radius:3px;}
 `}</style>

 {/* Header */}
 <div style={{ background:"rgba(240,244,250,0.97)", backdropFilter:"blur(20px)", borderBottom:"1px solid "+C.border, padding:"0 32px", height:70, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
 <div style={{ display:"flex", alignItems:"center", gap:12 }}>
 <ActureLogo size={42}/>
 <div>
 <div style={{ fontSize:15, fontWeight:700, color:C.text }}>ACTURE MEDIA</div>
 <div style={{ fontSize:11, color:C.accent, letterSpacing:2, textTransform:"uppercase" }}>Careers Portal</div>
 </div>
 </div>
 <div style={{ fontSize:12, color:C.muted }}>Digital Growth Marketing · Mumbai</div>
 </div>

 {/* Hero */}
 <div style={{ background:C.surface, padding:"28px 32px", textAlign:"center", borderBottom:"1px solid "+C.border }}>
 <div style={{ fontSize:11, color:C.accent, fontWeight:700, textTransform:"uppercase", letterSpacing:3, marginBottom:8 }}>We're Hiring</div>
 <div style={{ fontSize:28, fontWeight:800, color:C.text, marginBottom:8, lineHeight:1.2 }}>Join <span style={{color:C.accent}}>Acture Media</span></div>
 <div style={{ fontSize:14, color:C.sub, maxWidth:480, margin:"0 auto", lineHeight:1.6 }}>
 Upload your resume and our AI will match your profile to open roles.
 </div>
 </div>

 {/* Form */}
 <div style={{ maxWidth:680, margin:"0 auto", padding:"28px 24px" }}>

 {/* JD / Role selector */}
 <div style={{ marginBottom:24 }}>
 <div style={{ fontSize:14, color:C.text, fontWeight:600, marginBottom:8 }}>
 Which role are you applying for? <span style={{color:C.accent}}>*</span>
 </div>
 {openJDs.length === 0 ? (
 <div style={{ background:C.card, border:"1px solid "+C.border, borderRadius:12, padding:"16px", color:C.muted, fontSize:14, textAlign:"center" }}>
 No open roles right now. Check back soon, or submit your resume for future opportunities below.
 </div>
 ) : (
 <select value={selectedJDId} onChange={e => setSelectedJDId(e.target.value)}
 style={{ width:"100%", background:C.card, border:"1px solid "+(selectedJDId ? C.accent+"80" : C.border), borderRadius:12, padding:"14px 16px", color:selectedJDId ? C.text : C.muted, fontSize:14, outline:"none", boxSizing:"border-box", fontFamily:"'Poppins', sans-serif" }}>
 <option value="">Select a role you're applying for...</option>
 {openJDs.map(j => <option key={j.id} value={j.id}>{j.title}{j.department ? " · " + j.department : ""}{j.experience ? " · " + j.experience : ""}</option>)}
 </select>
 )}
 {selectedJDId && (() => {
 const jd = openJDs.find(j => j.id === selectedJDId);
 return jd ? (
 <div style={{ marginTop:10, background:C.accent+"12", border:"1px solid "+C.accent+"35", borderRadius:10, padding:"10px 16px", fontSize:12, color:C.accent, display:"flex", alignItems:"center", gap:8 }}>
 <span></span>
 <span><strong>{jd.title}</strong> · {jd.department}{jd.experience ? " · " + jd.experience : ""}</span>
 <span style={{marginLeft:"auto",opacity:0.7}}>Your resume will be scored against this JD</span>
 </div>
 ) : null;
 })()}
 </div>

 {/* Drop zone */}
 {!useManual && (
 <div onDragOver={e=>{e.preventDefault();setDragging(true);}} onDragLeave={()=>setDragging(false)} onDrop={onDrop}
 onClick={()=>fileRef.current?.click()}
 style={{ border:"2px dashed "+(dragging?C.accent:C.border), borderRadius:20, padding:"52px 32px", textAlign:"center", background:dragging?C.accent+"08":C.card, cursor:"pointer", transition:"all 0.2s", marginBottom:16 }}>
 <div style={{ fontSize:52, marginBottom:16 }}></div>
 <div style={{ fontSize:20, fontWeight:700, color:C.text, marginBottom:8 }}>
 {dragging ? "Drop your resume here!" : "Drag & drop your resume"}
 </div>
 <div style={{ fontSize:14, color:C.muted, marginBottom:24 }}>PDF recommended · DOC · DOCX · TXT</div>
 <div style={{ display:"inline-block", background:C.accent, color:"#fff", borderRadius:10, padding:"12px 32px", fontSize:15, fontWeight:700 }}>
 Browse File
 </div>
 <input ref={fileRef} type="file" accept=".pdf,.doc,.docx,.txt" style={{display:"none"}}
 onChange={e=>{if(e.target.files[0])processFile(e.target.files[0]);e.target.value="";}}/>
 </div>
 )}

 <div style={{ textAlign:"center", marginBottom:16 }}>
 <button onClick={()=>setUseManual(!useManual)}
 style={{ background:"none", border:"1px solid "+C.border, borderRadius:8, padding:"8px 20px", color:C.muted, fontSize:13, cursor:"pointer", fontFamily:"'Poppins', sans-serif" }}>
 {useManual ? "↑ Back to File Upload" : " Paste Resume Text Instead"}
 </button>
 </div>

 {useManual && (
 <div style={{ background:C.card, border:"1px solid "+C.border, borderRadius:16, padding:24, marginBottom:16 }}>
 <div style={{ fontSize:13, color:C.muted, marginBottom:10 }}>Paste your resume text below</div>
 <textarea value={manualText} onChange={e=>setManualText(e.target.value)} placeholder="Copy and paste your complete resume here..." rows={10}
 style={{ width:"100%", background:C.surface, border:"1px solid "+C.border, borderRadius:8, padding:"12px 14px", color:C.text, fontSize:14, outline:"none", resize:"vertical", fontFamily:"'Poppins', sans-serif", boxSizing:"border-box" }}/>
 <div style={{ marginTop:14 }}>
 <button onClick={()=>processText(manualText)} disabled={manualText.trim().length<50}
 style={{ background:manualText.trim().length<50?C.surface:C.accent, color:manualText.trim().length<50?C.muted:"#fff", border:"none", borderRadius:10, padding:"12px 28px", fontSize:14, fontWeight:700, cursor:manualText.trim().length<50?"not-allowed":"pointer", opacity:manualText.trim().length<50?0.5:1, fontFamily:"'Poppins', sans-serif" }}>
 Submit Resume
 </button>
 </div>
 </div>
 )}

 {errorDetail && <div style={{ background:C.red+"15", border:"1px solid "+C.red+"40", borderRadius:12, padding:"14px 18px", color:"#fca5a5", fontSize:13, marginBottom:16 }}> {errorDetail}</div>}
 </div>

 <div style={{ borderTop:"1px solid "+C.border, padding:"24px 32px", textAlign:"center" }}>
 <div style={{ fontSize:12, color:C.muted }}>© 2026 Acture Media · HR Portal · <span style={{color:C.sub}}>Mumbai, India</span></div>
 </div>
 </div>
 );
}

// ===============================================================================
// --- HR LOGIN SCREEN ----------------------------------------------------------
// ===============================================================================

async function getCustomPass(username) {
 try {
 if (db.ready()) {
 const rows = await db.getAll("settings");
 const row = (rows||[]).find(r => r.id === "cp_"+username);
 if (row?.data?.password) return row.data.password;
 }
 } catch {}
 try { return localStorage.getItem("acture_cp_"+username)||null; } catch { return null; }
}
async function saveCustomPass(username, pass) {
 try {
 if (db.ready()) { await db.upsert("settings","cp_"+username,{password:pass}); return; }
 } catch {}
 try { localStorage.setItem("acture_cp_"+username, pass); } catch {}
}

function HRLogin({ onLogin }) {
 const [username, setUsername] = useState("");
 const [password, setPassword] = useState("");
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(false);
 const [loginType, setLoginType] = useState("hr");

 const [pwMode, setPwMode] = useState("idle");
 const [verifyPass, setVerifyPass] = useState("");
 const [newPass, setNewPass] = useState("");
 const [confirmPass, setConfirmPass] = useState("");
 const [pwMsg, setPwMsg] = useState("");

 async function getBossPassword(b) {
 const custom = await getCustomPass(b.username);
 return custom || b.password;
 }

 async function attempt() {
 setLoading(true);
 const boss = BOSSES.find(b => b.username === username.toLowerCase());
 if (boss) {
 const correctPass = await getBossPassword(boss);
 if (correctPass === password) {
 sessionStorage.setItem("hr_auth", "true");
 sessionStorage.setItem("hr_user", JSON.stringify({ name: boss.name, role: boss.role, avatar: boss.avatar, type: "boss" }));
 onLogin({ name: boss.name, role: boss.role, avatar: boss.avatar, type: "boss" });
 setLoading(false); return;
 }
 }
 if (loginType === "hr" && password === HR_PASSWORD) {
 sessionStorage.setItem("hr_auth", "true");
 sessionStorage.setItem("hr_user", JSON.stringify({ name: "HR Team", role: "HR Staff", avatar: "HR", type: "staff" }));
 onLogin({ name: "HR Team", role: "HR Staff", avatar: "HR", type: "staff" });
 setLoading(false); return;
 }
 setError("Incorrect credentials. Please try again.");
 setPassword(""); setUsername("");
 setLoading(false);
 }

 function startSetPassword() {
 if (!username) { setError("Please select or enter your username first."); return; }
 const boss = BOSSES.find(b => b.username === username.toLowerCase());
 if (!boss) { setError("Username not found."); return; }
 setError(""); setPwMode("verify"); setVerifyPass(""); setNewPass(""); setConfirmPass(""); setPwMsg("");
 }

 async function verifyAndProceed() {
 const boss = BOSSES.find(b => b.username === username.toLowerCase());
 if (!boss) return;
 const correctPass = await getBossPassword(boss);
 if (correctPass !== verifyPass) { setPwMsg("Current password is incorrect."); return; }
 setPwMode("set"); setPwMsg("");
 }

 async function saveNewPassword() {
 if (newPass.length < 6) { setPwMsg("Password must be at least 6 characters."); return; }
 if (newPass !== confirmPass) { setPwMsg("Passwords don't match."); return; }
 await saveCustomPass(username.toLowerCase(), newPass);
 setPwMsg(""); setPwMode("idle"); setPassword("");
 setError(" Password saved to Supabase! Please log in with your new password.");
 setTimeout(() => setError(""), 3500);
 }

 const inputStyle = (hasErr) => ({ width:"100%", background:C.surface, border:"1px solid "+(hasErr?C.red:C.border), borderRadius:10, padding:"13px 16px", color:C.text, fontSize:14, outline:"none", boxSizing:"border-box", fontFamily:"'Poppins', sans-serif" });

 return (
 // *** CHANGE 2: fontFamily updated to Poppins ***
 <div style={{ minHeight:"100vh", background:C.bg, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Poppins', sans-serif" }}>
 <style>{`
 @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');
 *{box-sizing:border-box;}
 `}</style>
 <div style={{ width:"100%", maxWidth:440, padding:24 }}>
 <div style={{ textAlign:"center", marginBottom:40 }}>
 <ActureLogo size={56}/>
 <div style={{ fontSize:24, fontWeight:800, color:C.text, marginTop:16 }}>HR Intelligence Portal</div>
 <div style={{ fontSize:13, color:C.muted, marginTop:6 }}>Acture Media · Internal Access Only</div>
 </div>

 <div style={{ display:"flex", background:C.surface, borderRadius:12, padding:4, marginBottom:24, border:"1px solid "+C.border }}>
 {[["hr","HR Staff Login"],["boss","Leadership Login"]].map(([type,label])=>(
 <button key={type} onClick={()=>{setLoginType(type);setError("");setUsername("");setPassword("");setPwMode("idle");}}
 style={{ flex:1, background:loginType===type?C.accent:"transparent", color:loginType===type?"#fff":C.muted, border:"none", borderRadius:8, padding:"10px 0", fontSize:13, fontWeight:600, cursor:"pointer", transition:"all 0.2s", fontFamily:"'Poppins', sans-serif" }}>
 {label}
 </button>
 ))}
 </div>

 <div style={{ background:C.card, border:"1px solid "+C.border, borderRadius:20, padding:32 }}>

 {pwMode === "idle" && (<>
 {loginType === "boss" && (
 <div style={{ marginBottom:16 }}>
 <div style={{ fontSize:13, color:C.muted, marginBottom:8 }}>Username</div>
 <input value={username} onChange={e=>{setUsername(e.target.value);setError("");}} placeholder="jennifer / jay / raj"
 style={inputStyle(!!error && !error.startsWith(""))}/>
 </div>
 )}
 <div style={{ marginBottom:8 }}>
 <div style={{ fontSize:13, color:C.muted, marginBottom:8 }}>Password</div>
 <input type="password" value={password} onChange={e=>{setPassword(e.target.value);setError("");}}
 onKeyDown={e=>e.key==="Enter"&&attempt()} placeholder="Enter password..."
 style={inputStyle(!!error && !error.startsWith(""))} autoFocus/>
 </div>
 {error && <div style={{ fontSize:12, color: error.startsWith("")?C.green:C.red, marginBottom:12 }}>{error}</div>}
 {!error && <div style={{ height:12 }}/>}
 <button onClick={attempt} disabled={!password||loading}
 style={{ width:"100%", background:!password||loading?C.surface:C.accent, color:!password||loading?C.muted:"#fff", border:"none", borderRadius:10, padding:13, fontSize:15, fontWeight:700, cursor:!password||loading?"not-allowed":"pointer", opacity:!password?0.5:1, transition:"all 0.15s", fontFamily:"'Poppins', sans-serif" }}>
 {loading?"Verifying...":" Enter HR Dashboard"}
 </button>

 {loginType === "boss" && (<>
 <div style={{ marginTop:20, display:"flex", gap:10, justifyContent:"center" }}>
 {BOSSES.map(b => (
 <div key={b.username} style={{ textAlign:"center", cursor:"pointer" }} onClick={()=>{setUsername(b.username);setError("");}}>
 <div style={{ width:40, height:40, borderRadius:"50%", background:C.accent, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, color:"#fff", margin:"0 auto 4px", border:username===b.username?"3px solid "+C.cyan:"2px solid transparent" }}>{b.avatar}</div>
 <div style={{ fontSize:10, color:C.muted }}>{b.name.split(" ")[0]}</div>
 </div>
 ))}
 </div>
 <button onClick={startSetPassword}
 style={{ marginTop:16, width:"100%", background:"transparent", color:C.muted, border:"1px dashed "+C.border, borderRadius:10, padding:"10px 0", fontSize:12, cursor:"pointer", fontFamily:"'Poppins', sans-serif" }}>
 Forgot / Set My Own Password
 </button>
 </>)}

 <div style={{ marginTop:16, padding:"12px 16px", background:C.surface, borderRadius:10, fontSize:12, color:C.muted, textAlign:"center" }}>
 This portal is for Acture Media HR team only.
 </div>
 </>)}

 {pwMode === "verify" && (<>
 <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:4 }}> Set New Password</div>
 <div style={{ fontSize:12, color:C.muted, marginBottom:20 }}>Verify your current password for <strong>{username}</strong></div>
 <div style={{ marginBottom:14 }}>
 <div style={{ fontSize:13, color:C.muted, marginBottom:8 }}>Current Password</div>
 <input type="password" value={verifyPass} onChange={e=>{setVerifyPass(e.target.value);setPwMsg("");}}
 onKeyDown={e=>e.key==="Enter"&&verifyAndProceed()} placeholder="Enter current password..."
 style={inputStyle(pwMsg.includes("incorrect"))} autoFocus/>
 </div>
 {pwMsg && <div style={{ fontSize:12, color:C.red, marginBottom:10 }}>{pwMsg}</div>}
 <div style={{ display:"flex", gap:10 }}>
 <button onClick={()=>setPwMode("idle")} style={{ flex:1, background:C.surface, color:C.muted, border:"1px solid "+C.border, borderRadius:10, padding:11, fontSize:13, cursor:"pointer", fontFamily:"'Poppins', sans-serif" }}>Cancel</button>
 <button onClick={verifyAndProceed} disabled={!verifyPass}
 style={{ flex:2, background:verifyPass?C.accent:C.surface, color:verifyPass?"#fff":C.muted, border:"none", borderRadius:10, padding:11, fontSize:13, fontWeight:700, cursor:verifyPass?"pointer":"not-allowed", fontFamily:"'Poppins', sans-serif" }}>
 Verify →
 </button>
 </div>
 </>)}

 {pwMode === "set" && (<>
 <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:4 }}> Create New Password</div>
 <div style={{ fontSize:12, color:C.muted, marginBottom:20 }}>Choose a new password for <strong>{username}</strong>. Your base password remains as backup.</div>
 <div style={{ marginBottom:12 }}>
 <div style={{ fontSize:13, color:C.muted, marginBottom:8 }}>New Password</div>
 <input type="password" value={newPass} onChange={e=>{setNewPass(e.target.value);setPwMsg("");}} placeholder="Min. 6 characters"
 style={inputStyle(pwMsg.includes("6 char"))} autoFocus/>
 </div>
 <div style={{ marginBottom:14 }}>
 <div style={{ fontSize:13, color:C.muted, marginBottom:8 }}>Confirm New Password</div>
 <input type="password" value={confirmPass} onChange={e=>{setConfirmPass(e.target.value);setPwMsg("");}}
 onKeyDown={e=>e.key==="Enter"&&saveNewPassword()} placeholder="Re-enter new password"
 style={inputStyle(pwMsg.includes("match"))}/>
 </div>
 {pwMsg && <div style={{ fontSize:12, color:C.red, marginBottom:10 }}>{pwMsg}</div>}
 <div style={{ marginBottom:14, padding:"10px 14px", background:C.surface, borderRadius:8, fontSize:11, color:C.muted }}>
 Your original base password ({BOSSES.find(b=>b.username===username)?.password}) always works as a backup.
 </div>
 <div style={{ display:"flex", gap:10 }}>
 <button onClick={()=>setPwMode("idle")} style={{ flex:1, background:C.surface, color:C.muted, border:"1px solid "+C.border, borderRadius:10, padding:11, fontSize:13, cursor:"pointer", fontFamily:"'Poppins', sans-serif" }}>Cancel</button>
 <button onClick={saveNewPassword} disabled={!newPass||!confirmPass}
 style={{ flex:2, background:newPass&&confirmPass?C.green:C.surface, color:newPass&&confirmPass?"#fff":C.muted, border:"none", borderRadius:10, padding:11, fontSize:13, fontWeight:700, cursor:newPass&&confirmPass?"pointer":"not-allowed", fontFamily:"'Poppins', sans-serif" }}>
 Save Password
 </button>
 </div>
 </>)}

 </div>
 </div>
 </div>
 );
}

// --- NAV ----------------------------------------------------------------------
const TABS = [
 { id:"dashboard", label:"Dashboard", icon:"DB" },
 { id:"upload", label:"Upload Resume", icon:"↑" },
 { id:"pool", label:"Talent Pool", icon:"o" },
 { id:"hrf", label:"Requisitions", icon:"" },
 { id:"jd", label:"JD Builder", icon:"" },
 { id:"excel", label:"Excel Manager", icon:"" },
 { id:"feedback", label:"Feedback", icon:"" },
 { id:"pipeline", label:"SOP Pipeline", icon:"#" },
 { id:"matching", label:"Role Match", icon:"o" },
];

function Nav({ tab, setTab, badges, onLogout, currentUser }) {
 return (
 <nav style={{position:"fixed",top:0,left:0,right:0,zIndex:100,background:"rgba(240,244,250,0.97)",backdropFilter:"blur(20px)",borderBottom:"1px solid "+C.border,height:70,display:"flex",alignItems:"center",padding:"0 20px",gap:4,fontFamily:"'Poppins', sans-serif"}}>
 <div style={{display:"flex",alignItems:"center",gap:10,marginRight:20,flexShrink:0}}>
 <ActureLogo size={38}/>
 <div>
 <div style={{fontSize:14,fontWeight:700,color:C.text,lineHeight:1.1}}>ACTURE MEDIA</div>
 <div style={{fontSize:10,color:C.accent,letterSpacing:2,textTransform:"uppercase"}}>HR Intelligence</div>
 </div>
 </div>
 <div style={{display:"flex",gap:1,flex:1,overflowX:"auto"}}>
 {TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{background:tab===t.id?C.accent+"18":"transparent",border:tab===t.id?"1px solid "+C.accent+"60":"1px solid transparent",color:tab===t.id?C.accent:C.sub,borderRadius:8,padding:"8px 13px",fontSize:12,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:4,whiteSpace:"nowrap",transition:"all 0.15s",fontFamily:"'Poppins', sans-serif"}}>
 {t.icon} {t.label}
 {(badges[t.id]||0)>0&&<span style={{background:C.accent,color:"#fff",borderRadius:"50%",width:16,height:16,fontSize:9,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>{badges[t.id]}</span>}
 </button>
 ))}
 </div>
 <div style={{display:"flex",alignItems:"center",gap:10,flexShrink:0,marginLeft:8}}>
 {currentUser && (
 <div style={{display:"flex",alignItems:"center",gap:8}}>
 <div style={{width:32,height:32,borderRadius:"50%",background:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:"#fff"}}>{currentUser.avatar}</div>
 </div>
 )}
 <div style={{fontSize:11,color:C.muted}}>
 {db.ready()?<span style={{color:C.green}}>● Live</span>:<span style={{color:C.gold}}>● Local</span>}
 </div>
 <button onClick={onLogout} style={{background:C.surface,border:"1px solid "+C.border,borderRadius:8,padding:"6px 12px",color:C.muted,fontSize:11,cursor:"pointer",fontFamily:"'Poppins', sans-serif"}}>Logout</button>
 </div>
 </nav>
 );
}

// --- DASHBOARD ----------------------------------------------------------------
function Dashboard({ candidates, jobs, jdDocs, feedbacks, setTab, currentUser }) {
 const total = candidates.length;
 const avgScore = total ? Math.round(candidates.reduce((s,c)=>s+getDisplayScore(c),0)/total) : 0;
 const highFit = candidates.filter(c=>getDisplayScore(c)>=75).length;
 const portalApps = candidates.filter(c=>c.source==="Candidate Portal").length;
 const jdScored = candidates.filter(c=>c.jdFitScore!=null).length;

 const deptCounts = DEPTS.map(d=>({ d, n:candidates.filter(c=>c.departments?.includes(d)).length })).sort((a,b)=>b.n-a.n);
 const statusCounts = STATUSES.map(s=>({ s, n:candidates.filter(c=>c.status===s).length }));

 const StatCard = ({label,val,sub}) => (
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:16,padding:"24px 28px",flex:1,minWidth:140}}>
 <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:1.5,marginBottom:8}}>{label}</div>
 <div style={{fontSize:42,fontWeight:800,color:C.text,margin:"0 0 4px"}}>{val}</div>
 <div style={{fontSize:12,color:C.muted}}>{sub}</div>
 </div>
 );

 return (
 <div>
 <div style={{marginBottom:28,background:C.card,border:"1px solid "+C.border,borderRadius:20,padding:"28px 32px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
 <div>
 <div style={{fontSize:13,color:C.accent,fontWeight:600,textTransform:"uppercase",letterSpacing:2,marginBottom:6}}>Acture Media HR Intelligence</div>
 <h2 style={{fontSize:32,fontWeight:800,color:C.text,margin:0}}>
 Welcome back{currentUser?.type==="boss"?", "+currentUser.name.split(" ")[0]:""}
 </h2>
 <p style={{fontSize:14,color:C.muted,margin:"6px 0 0"}}>{db.ready()?"Connected to Supabase":"Using local storage"} · {new Date().toLocaleDateString("en-IN",{weekday:"long",year:"numeric",month:"long",day:"numeric"})}</p>
 </div>
 <div style={{display:"flex",gap:10}}>
 <button onClick={()=>setTab("upload")} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"12px 24px",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"'Poppins', sans-serif"}}>↑ Upload Resume</button>
 </div>
 </div>

 {portalApps > 0 && (
 <div style={{background:C.accent+"12",border:"1px solid "+C.accent+"40",borderRadius:12,padding:"12px 20px",marginBottom:20,display:"flex",alignItems:"center",gap:12}}>
 <span style={{fontSize:20}}></span>
 <div><span style={{fontSize:14,fontWeight:700,color:C.accent}}>{portalApps} application{portalApps>1?"s":""} from Candidate Portal</span><span style={{fontSize:13,color:C.muted,marginLeft:8}}>— submitted via public link</span></div>
 <button onClick={()=>setTab("pool")} style={{marginLeft:"auto",background:"none",border:"1px solid "+C.accent+"40",borderRadius:6,padding:"4px 12px",color:C.accent,fontSize:12,cursor:"pointer",fontFamily:"'Poppins', sans-serif"}}>View in Talent Pool →</button>
 </div>
 )}

 <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:24}}>
 <StatCard label="Total Candidates" val={total} sub="in talent pool"/>
 <StatCard label="Portal Apps" val={portalApps} sub="from public link"/>
 <StatCard label="JD-Scored" val={jdScored} sub="scored vs JD"/>
 <StatCard label="Avg Fit Score" val={avgScore} sub="out of 100"/>
 <StatCard label="High-Fit ≥75" val={highFit} sub="ready pool"/>
 <StatCard label="Active Roles" val={jobs.filter(j=>j.status==="Active").length} sub="requisitions"/>
 </div>

 <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,marginBottom:24}}>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:16,padding:24}}>
 <div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:18}}>By Department</div>
 {deptCounts.map(({d,n})=>{
 const pct=total?Math.round((n/total)*100):0;
 return (
 <div key={d} style={{marginBottom:10}}>
 <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
 <span style={{fontSize:12,color:C.sub}}>{d}</span>
 <span style={{fontSize:12,color:C.text,fontWeight:600}}>{n}</span>
 </div>
 <div style={{height:6,background:C.border,borderRadius:3}}>
 <div style={{height:"100%",width:pct+"%",background:C.accent,borderRadius:3,transition:"width 0.5s"}}/>
 </div>
 </div>
 );
 })}
 </div>
 <div style={{display:"flex",flexDirection:"column",gap:16}}>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:16,padding:24}}>
 <div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:14}}>Pipeline Status</div>
 <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
 {statusCounts.map(({s,n})=>(
 <div key={s} style={{background:C.surface,border:"1px solid "+C.border,borderRadius:10,padding:"10px 14px",textAlign:"center",minWidth:72}}>
 <div style={{fontSize:22,fontWeight:800,color:C.text}}>{n}</div>
 <div style={{fontSize:10,color:C.muted}}>{s}</div>
 </div>
 ))}
 </div>
 </div>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:16,padding:24}}>
 <div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:14}}>By Seniority</div>
 <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
 {LEVELS.map(l=>(
 <div key={l} style={{background:C.surface,border:"1px solid "+C.border,borderRadius:10,padding:"10px 14px",textAlign:"center"}}>
 <div style={{fontSize:24,fontWeight:800,color:C.text}}>{candidates.filter(c=>c.seniority===l).length}</div>
 <div style={{fontSize:10,color:C.muted}}>{l}</div>
 </div>
 ))}
 </div>
 </div>
 </div>
 </div>

 {highFit>0&&(
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:16,padding:24}}>
 <div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:16}}> High-Fit Ready Pool</div>
 <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
 {candidates.filter(c=>getDisplayScore(c)>=75).map(c=>(
 <div key={c.id} style={{background:C.surface,border:"1px solid "+C.border,borderRadius:12,padding:"14px 18px"}}>
 <div style={{fontSize:13,fontWeight:700,color:C.text}}>{c.name}</div>
 {c.appliedRole&&<div style={{fontSize:10,color:C.accent,marginBottom:6}}>{c.appliedRole}</div>}
 <div style={{fontSize:11,color:C.sub,margin:"2px 0 8px"}}>{c.currentTitle}</div>
 <ScoreBadge score={getDisplayScore(c)} jdBased={c.jdFitScore!=null}/>
 </div>
 ))}
 </div>
 </div>
 )}

 {total===0&&(
 <div style={{background:C.card,border:"2px dashed "+C.border,borderRadius:16,padding:56,textAlign:"center"}}>
 <div style={{fontSize:48,marginBottom:12}}></div>
 <div style={{fontSize:15,color:C.sub}}>No candidates yet. Share your public portal link or upload resumes directly.</div>
 <button onClick={()=>setTab("upload")} style={{marginTop:20,background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"12px 28px",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"'Poppins', sans-serif"}}>Upload First Resume</button>
 </div>
 )}
 </div>
 );
}

// --- CONTACT EDIT BLOCK -------------------------------------------------------
function ContactEditBlock({ result, setResult, missing, filled, candidates, setCandidates, dbSave }) {
 const [edits, setEdits] = useState({});
 const [saved, setSaved] = useState(false);
 const [saving, setSaving] = useState(false);

 function setField(k, v) { setEdits(p=>({...p,[k]:v})); setSaved(false); }

 async function saveContact() {
 if (Object.keys(edits).length === 0) return;
 setSaving(true);
 const updated = { ...result, ...edits };
 setResult(updated);
 const allCands = candidates.map(c => c.id === updated.id ? updated : c);
 setCandidates(allCands);
 await dbSave("candidates","acture_candidates", updated.id, updated, allCands);
 setSaved(true); setSaving(false);
 }

 const hasMissing = missing.length > 0;

 return (
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:16,padding:20,marginBottom:16}}>
 <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
 <div>
 <div style={{fontSize:13,fontWeight:700,color:C.text}}> Contact Details</div>
 {hasMissing && <div style={{fontSize:11,color:C.gold,marginTop:2}}> {missing.length} field{missing.length>1?"s":""} not parsed — fill them in below</div>}
 </div>
 {Object.keys(edits).length>0&&(
 <button onClick={saveContact} disabled={saving}
 style={{background:saved?C.green:C.accent,color:"#fff",border:"none",borderRadius:8,padding:"7px 16px",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'Poppins', sans-serif"}}>
 {saving?"Saving...":(saved?" Saved":" Save Changes")}
 </button>
 )}
 </div>

 {filled.length>0&&(
 <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:hasMissing?14:0}}>
 {filled.map(([k,icon,label])=>(
 <div key={k} style={{background:C.surface,border:"1px solid "+C.border,borderRadius:8,padding:"6px 12px",fontSize:12}}>
 <span style={{color:C.muted}}>{icon} {label}: </span>
 <span style={{color:C.text,fontWeight:600}}>{edits[k]||result[k]}</span>
 </div>
 ))}
 </div>
 )}

 {hasMissing&&(
 <div style={{background:C.gold+"10",border:"1px solid "+C.gold+"40",borderRadius:10,padding:14}}>
 <div style={{fontSize:11,color:C.gold,fontWeight:700,marginBottom:10,textTransform:"uppercase",letterSpacing:1}}>Add Missing Details</div>
 <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
 {missing.map(([k,icon,label,ph])=>(
 <div key={k}>
 <div style={{fontSize:11,color:C.muted,marginBottom:4}}>{icon} {label}</div>
 <input
 value={edits[k]!==undefined?edits[k]:(result[k]&&result[k]!=="Not mentioned"?result[k]:"")}
 onChange={e=>setField(k,e.target.value)}
 placeholder={ph}
 style={{width:"100%",background:C.card,border:"1px solid "+C.border,borderRadius:8,padding:"9px 12px",fontSize:13,color:C.text,outline:"none",boxSizing:"border-box",fontFamily:"'Poppins', sans-serif"}}
 />
 </div>
 ))}
 </div>
 {Object.keys(edits).length>0&&(
 <button onClick={saveContact} disabled={saving}
 style={{marginTop:12,background:saved?C.green:C.accent,color:"#fff",border:"none",borderRadius:8,padding:"9px 20px",fontSize:13,fontWeight:700,cursor:"pointer",width:"100%",fontFamily:"'Poppins', sans-serif"}}>
 {saving?"Saving...":(saved?" Contact Details Saved!":" Save Contact Details")}
 </button>
 )}
 </div>
 )}
 </div>
 );
}

// --- UPLOAD RESUME ------------------------------------------------------------
function UploadResume({ candidates, setCandidates, showToast, jdDocs, currentUser }) {
 const [dragging, setDragging] = useState(false);
 const [parsing, setParsing] = useState(false);
 const [stepIndex, setStepIndex] = useState(0);
 const [errorDetail, setErrorDetail] = useState("");
 const [result, setResult] = useState(null);
 const [manualText, setManualText] = useState("");
 const [useManual, setUseManual] = useState(false);
 const [fileName, setFileName] = useState("");
 const [selectedJDId, setSelectedJDId] = useState("");
 const fileRef = useRef();
 const tick = (n) => new Promise(r => setTimeout(()=>{setStepIndex(n);r();},420));

 async function finishAndSave(parsed) {
 if (!parsed) { setParsing(false); setErrorDetail("AI returned unparseable data. Try 'Paste Resume Text' mode."); return; }
 const sc = parsed.scoring || {};
 const candidate = {
 id: uid(), uploadedAt: new Date().toISOString(), status: "Applied", fileName,
 source: "HR Upload",
 uploadedBy: currentUser ? currentUser.name : "HR Staff",
 selectedJDId: selectedJDId || "",
 appliedRole: "", appliedDept: "",
 jdFitScore: null, jdFitReason: "",
 name: parsed.name || fileName.replace(/\.[^.]+$/,""),
 email: parsed.email||"", phone: parsed.phone||"", location: parsed.location||"",
 linkedin: parsed.linkedin||"", portfolio: parsed.portfolio||"",
 currentTitle: parsed.currentTitle||"N/A", currentCompany: parsed.currentCompany||"N/A",
 previousCompanies: Array.isArray(parsed.previousCompanies)?parsed.previousCompanies:[],
 totalYearsExp: Number(parsed.totalYearsExp)||0,
 seniority: parsed.seniority||"Associate",
 departments: Array.isArray(parsed.departments)&&parsed.departments.length?parsed.departments:["General"],
 skills: Array.isArray(parsed.skills)?parsed.skills:[],
 tools: Array.isArray(parsed.tools)?parsed.tools:[],
 noticePeriod: parsed.noticePeriod||"Not mentioned",
 expectedCTC: parsed.expectedCTC||"",
 summary: parsed.summary||"",
 strengths: Array.isArray(parsed.strengths)?parsed.strengths:[],
 risks: Array.isArray(parsed.risks)?parsed.risks:[],
 fitReason: parsed.fitReason||"",
 scoring: {
 skillMatchScore: Number(sc.skillMatchScore||sc.skillMatch)||20,
 experienceRelevance: Number(sc.experienceRelevance||sc.expRelevance)||10,
 toolExpertise: Number(sc.toolExpertise||sc.toolDepth)||8,
 seniorityMatch: Number(sc.seniorityMatch)||5,
 industryMatch: Number(sc.industryMatch)||5,
 stabilityScore: Number(sc.stabilityScore)||2,
 },
 };

 const selectedJD = jdDocs.find(j=>j.id===selectedJDId);
 if (selectedJD) {
 candidate.appliedRole = selectedJD.title;
 candidate.appliedDept = selectedJD.department;
 const jdResult = await calcJDFitScore(candidate, selectedJD);
 if (jdResult) { candidate.jdFitScore = jdResult.score; candidate.jdFitReason = jdResult.reason; }
 }

 const updated = [...candidates, candidate];
 setCandidates(updated);
 await dbSave("candidates","acture_candidates",candidate.id,candidate,updated);
 await tick(6);
 await new Promise(r=>setTimeout(r,500));
 setParsing(false); setResult(candidate);
 const displayScore = candidate.jdFitScore != null ? candidate.jdFitScore : calcScore(candidate.scoring);
 showToast(" "+candidate.name+" added — Fit Score: "+displayScore+"/100"+(selectedJD?" (vs "+selectedJD.title+")":""),"success");
 }

 async function processFile(file) {
 if (!file) return;
 const ext = file.name.split(".").pop().toLowerCase();
 if (!["pdf","doc","docx","txt"].includes(ext)) { setErrorDetail("Only PDF, DOC, DOCX, TXT supported."); return; }
 setErrorDetail(""); setResult(null); setFileName(file.name); setParsing(true); setStepIndex(0);
 try {
 await tick(1); const fileData = await readFile(file);
 await tick(2); await tick(3); await tick(4); await tick(5);
 await finishAndSave(await parseResume(fileData));
 } catch (err) { setParsing(false); setErrorDetail("Parsing failed: "+err.message); }
 }

 async function processText(text) {
 setErrorDetail(""); setResult(null); setFileName("pasted-text.txt"); setParsing(true); setStepIndex(0);
 try {
 await tick(1); await tick(2); await tick(3); await tick(4); await tick(5);
 await finishAndSave(await parseResume({type:"text",data:text}));
 } catch (err) { setParsing(false); setErrorDetail("Parsing failed: "+err.message); }
 }

 const onDrop = useCallback((e)=>{e.preventDefault();setDragging(false);processFile(e.dataTransfer.files[0]);},[candidates,selectedJDId,jdDocs]);
 function reset(){setResult(null);setManualText("");setFileName("");setErrorDetail("");setParsing(false);setStepIndex(0);setSelectedJDId("");}

 const score = result ? (result.jdFitScore!=null ? result.jdFitScore : calcScore(result.scoring)) : 0;
 const scoreCol = C.accent;

 if (parsing) return (
 <div>
 <h2 style={{fontSize:30,fontWeight:800,color:C.text,margin:"0 0 8px"}}>Resume Upload & AI Parsing</h2>
 <p style={{fontSize:14,color:C.muted,margin:"0 0 20px"}}>Parsing resume natively…</p>
 <ParsingUI fileName={fileName} stepIndex={stepIndex}/>
 </div>
 );

 return (
 <div>
 <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
 <h2 style={{fontSize:30,fontWeight:800,color:C.text,margin:0}}>Resume Upload & AI Parsing</h2>
 {currentUser && (
 <div style={{display:"flex",alignItems:"center",gap:8,background:C.card,border:"1px solid "+C.border,borderRadius:10,padding:"7px 14px"}}>
 <div style={{width:28,height:28,borderRadius:"50%",background:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff"}}>{currentUser.avatar}</div>
 <div>
 <div style={{fontSize:11,color:C.muted,lineHeight:1}}>Uploading as</div>
 <div style={{fontSize:13,fontWeight:700,color:C.text,lineHeight:1.4}}>{currentUser.name}</div>
 </div>
 </div>
 )}
 </div>
 <p style={{fontSize:14,color:C.muted,margin:"0 0 20px"}}>PDF, DOC, TXT → JD-scored → saved to {db.ready()?"Supabase":"local storage"}</p>

 {!result&&(
 <>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:20,marginBottom:16}}>
 <div style={{fontSize:13,color:C.text,fontWeight:600,marginBottom:10}}> Score against a Job Description (recommended)</div>
 <select value={selectedJDId} onChange={e=>setSelectedJDId(e.target.value)}
 style={{width:"100%",background:C.surface,color:selectedJDId?C.text:C.muted,border:"1px solid "+(selectedJDId?C.accent+"60":C.border),borderRadius:8,padding:"11px 14px",fontSize:14,boxSizing:"border-box",fontFamily:"'Poppins', sans-serif"}}>
 <option value="">No JD selected (use AI baseline score)</option>
 {jdDocs.map(j=><option key={j.id} value={j.id}>{j.title}{j.department?" · "+j.department:""}{j.experience?" · "+j.experience:""}</option>)}
 </select>
 {selectedJDId&&(()=>{const jd=jdDocs.find(j=>j.id===selectedJDId);return jd?(<div style={{marginTop:8,background:C.accent+"12",border:"1px solid "+C.accent+"30",borderRadius:8,padding:"8px 14px",fontSize:12,color:C.accent}}> Fit score will be calculated against <strong>{jd.title}</strong> requirements</div>):null;})()}
 {jdDocs.length===0&&<div style={{marginTop:8,fontSize:12,color:C.gold}}> No JDs available. Create one in JD Builder first.</div>}
 </div>

 <div onDragOver={e=>{e.preventDefault();setDragging(true);}} onDragLeave={()=>setDragging(false)} onDrop={onDrop}
 onClick={()=>!useManual&&fileRef.current?.click()}
 style={{border:"2px dashed "+(dragging?C.accent:C.border),borderRadius:16,padding:48,textAlign:"center",background:dragging?C.accent+"08":C.card,cursor:useManual?"default":"pointer",transition:"all 0.2s",marginBottom:14}}>
 <div style={{fontSize:44,marginBottom:12}}></div>
 <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:6}}>{dragging?"Drop it!":"Drag & drop resume here"}</div>
 <div style={{fontSize:12,color:C.muted,marginBottom:16}}>PDF (recommended) · DOC · DOCX · TXT</div>
 <Btn onClick={e=>{e.stopPropagation();fileRef.current?.click();}}>Browse File</Btn>
 <input ref={fileRef} type="file" accept=".pdf,.doc,.docx,.txt" style={{display:"none"}} onChange={e=>{if(e.target.files[0])processFile(e.target.files[0]);e.target.value="";}}/>
 </div>
 <div style={{textAlign:"center",marginBottom:12}}>
 <Btn variant="ghost" onClick={()=>setUseManual(!useManual)}>{useManual?"↑ Back to File Upload":" Paste Resume Text"}</Btn>
 </div>
 {useManual&&(
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:20}}>
 <Textarea label="Paste Resume Text" value={manualText} onChange={setManualText} placeholder="Paste complete resume here..." rows={8}/>
 <div style={{marginTop:12}}><Btn disabled={manualText.trim().length<50} onClick={()=>processText(manualText)}> Parse with AI</Btn></div>
 </div>
 )}
 {errorDetail&&<div style={{marginTop:12,background:C.red+"15",border:"1px solid "+C.red+"40",borderRadius:10,padding:"12px 16px",color:"#fca5a5",fontSize:12}}> {errorDetail}</div>}
 </>
 )}

 {result&&(
 <div>
 <div style={{background:C.green+"18",border:"1px solid "+C.green+"50",borderRadius:12,padding:"12px 20px",marginBottom:16,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
 <div style={{display:"flex",alignItems:"center",gap:10}}>
 <span style={{fontSize:18}}></span>
 <div>
 <div style={{fontSize:13,fontWeight:700,color:C.green}}>Saved to {db.ready()?"Supabase Database":"Local Storage"}</div>
 <div style={{fontSize:11,color:C.muted}}>Status: Applied · Visible in Talent Pool</div>
 </div>
 </div>
 <Btn onClick={reset}>↑ Upload Another</Btn>
 </div>
 <div style={{background:C.card,border:"1px solid "+scoreCol+"40",borderRadius:16,padding:24,marginBottom:16,display:"flex",alignItems:"center",gap:20}}>
 <div style={{width:80,height:80,borderRadius:"50%",background:"conic-gradient("+scoreCol+" "+(score*3.6)+"deg,"+C.border+" 0)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
 <div style={{width:64,height:64,borderRadius:"50%",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:17,fontWeight:800,color:scoreCol}}>{score}</div>
 </div>
 <div>
 <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:2}}>{result.jdFitScore!=null?"JD Fit Score · "+result.appliedRole:"Acture Fit Score"}</div>
 <div style={{fontSize:22,fontWeight:800,color:C.text}}>{result.name}</div>
 <div style={{fontSize:13,color:C.sub}}>{result.currentTitle} · {result.totalYearsExp} yrs exp</div>
 {result.jdFitReason&&<div style={{fontSize:12,color:C.muted,marginTop:6,fontStyle:"italic"}}>{result.jdFitReason}</div>}
 <div style={{fontSize:11,color:C.muted,marginTop:6}}>Added by <span style={{fontWeight:700,color:C.accent}}>{result.uploadedBy||"HR Staff"}</span></div>
 </div>
 </div>

 {(()=>{
 const missing = [
 ["email","","Email"],["phone","","Phone"],["location","","Location"],
 ["linkedin","","LinkedIn"],["noticePeriod","","Notice Period"],["expectedCTC","","Expected CTC"]
 ].filter(([k])=>!result[k]||result[k]==="Not mentioned"||result[k]==="");
 const filled = [
 ["email","","Email"],["phone","","Phone"],["location","","Location"],
 ["linkedin","","LinkedIn"],["noticePeriod","","Notice Period"],["expectedCTC","","Expected CTC"]
 ].filter(([k])=>result[k]&&result[k]!=="Not mentioned"&&result[k]!=="");
 return (filled.length>0||missing.length>0)&&(
 <ContactEditBlock result={result} setResult={setResult} missing={missing} filled={filled} candidates={candidates} setCandidates={setCandidates} dbSave={dbSave}/>
 );
 })()}
 </div>
 )}
 </div>
 );
}

// --- TALENT POOL --------------------------------------------------------------
function TalentPool({ candidates, setCandidates, showToast }) {
 const [search,setSearch]=useState("");
 const [filterDept,setFilterDept]=useState("All");
 const [filterStatus,setFilterStatus]=useState("All");
 const [filterLevel,setFilterLevel]=useState("All");
 const [filterSource,setFilterSource]=useState("All");
 const [minExp,setMinExp]=useState(0);
 const [selected,setSelected]=useState(null);

 const filtered = candidates.filter(c=>{
 const q=search.toLowerCase();
 return(!q||[c.name,c.currentTitle,...(c.skills||[]),...(c.tools||[]),...(c.departments||[])].join(" ").toLowerCase().includes(q))&&
 (filterDept==="All"||(c.departments?.includes(filterDept)||c.appliedDept===filterDept))&&
 (filterStatus==="All"||c.status===filterStatus)&&
 (filterLevel==="All"||c.seniority===filterLevel)&&
 (filterSource==="All"||c.source===filterSource)&&
 (c.totalYearsExp||0)>=minExp;
 }).sort((a,b)=>getDisplayScore(b)-getDisplayScore(a));

 async function updateStatus(id,status){ const updated=candidates.map(c=>c.id===id?{...c,status}:c); setCandidates(updated); await dbSave("candidates","acture_candidates",id,updated.find(c=>c.id===id),updated); }
 async function deleteCandidate(id){ const remaining=candidates.filter(c=>c.id!==id); setCandidates(remaining); await dbDelete("candidates","acture_candidates",id,remaining); setSelected(null); showToast("Candidate removed","success"); }

 return (
 <div>
 {selected&&(
 <div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.88)",display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={()=>setSelected(null)}>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:20,width:"100%",maxWidth:740,maxHeight:"90vh",overflow:"auto",padding:28}} onClick={e=>e.stopPropagation()}>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
 <div>
 <div style={{fontSize:20,fontWeight:800,color:C.text}}>{selected.name}</div>
 <div style={{fontSize:12,color:C.sub}}>{selected.currentTitle} · {selected.currentCompany}</div>
 {selected.source==="Candidate Portal"&&<span style={{fontSize:11,color:C.cyan,background:C.cyan+"15",border:"1px solid "+C.cyan+"30",borderRadius:5,padding:"2px 8px",marginTop:4,display:"inline-block"}}> Applied via Portal</span>}
 {selected.source==="HR Upload"&&selected.uploadedBy&&<span style={{fontSize:11,color:C.accent,background:C.accent+"12",border:"1px solid "+C.accent+"30",borderRadius:5,padding:"2px 8px",marginTop:4,display:"inline-block"}}> Uploaded by {selected.uploadedBy}</span>}
 {selected.appliedRole&&<div style={{fontSize:11,color:C.accent,marginTop:4}}>Applied for: {selected.appliedRole}</div>}
 </div>
 <div style={{display:"flex",gap:8,alignItems:"center"}}>
 <ScoreBadge score={getDisplayScore(selected)} jdBased={selected.jdFitScore!=null}/>
 <Btn variant="ghost" small onClick={()=>setSelected(null)}></Btn>
 </div>
 </div>

 {selected.jdFitReason&&(
 <div style={{background:C.accent+"12",border:"1px solid "+C.accent+"30",borderRadius:10,padding:"10px 16px",marginBottom:16,fontSize:12,color:C.accent}}>
 JD Fit: {selected.jdFitReason}
 </div>
 )}

 <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
 <div style={{background:C.card,borderRadius:12,padding:16}}>
 <div style={{fontSize:11,color:C.accent,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Contact</div>
 {[["Email",selected.email],["Phone",selected.phone],["Location",selected.location],["LinkedIn",selected.linkedin],["Notice Period",selected.noticePeriod],["Expected CTC",selected.expectedCTC],["Applied For",selected.appliedRole]].map(([k,v])=>v?(
 <div key={k} style={{display:"flex",gap:8,marginBottom:5}}><span style={{fontSize:11,color:C.muted,minWidth:100}}>{k}</span><span style={{fontSize:11,color:C.text}}>{v}</span></div>
 ):null)}
 </div>
 <div style={{background:C.card,borderRadius:12,padding:16}}>
 <div style={{fontSize:11,color:C.accent,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>
 {selected.jdFitScore!=null?"JD Fit Score":"AI Score"} Breakdown
 </div>
 {selected.jdFitScore!=null?(
 <div>
 <div style={{fontSize:24,fontWeight:800,color:C.accent,marginBottom:8}}>{selected.jdFitScore}/100</div>
 <div style={{fontSize:11,color:C.muted,fontStyle:"italic"}}>{selected.jdFitReason}</div>
 </div>
 ):selected.scoring&&[["Skill Match",selected.scoring.skillMatchScore,40],["Experience",selected.scoring.experienceRelevance,20],["Tool Depth",selected.scoring.toolExpertise,15],["Seniority",selected.scoring.seniorityMatch,10],["Industry",selected.scoring.industryMatch,10],["Stability",selected.scoring.stabilityScore,5]].map(([k,v,m])=>(
 <div key={k} style={{marginBottom:6}}>
 <div style={{display:"flex",justifyContent:"space-between",marginBottom:2}}><span style={{fontSize:11,color:C.sub}}>{k}</span><span style={{fontSize:11,fontWeight:700,color:C.text}}>{v}/{m}</span></div>
 <div style={{height:3,background:C.border,borderRadius:2}}><div style={{height:"100%",width:(v/m*100)+"%",background:C.accent,borderRadius:2}}/></div>
 </div>
 ))}
 </div>
 <div style={{background:C.card,borderRadius:12,padding:16}}>
 <div style={{fontSize:11,color:C.accent,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Skills & Tools</div>
 <div style={{marginBottom:8}}><div style={{fontSize:10,color:C.muted,marginBottom:5}}>Departments</div><div style={{display:"flex",flexWrap:"wrap",gap:4}}>{selected.departments?.map(d=><Tag key={d} label={d} color={C.purple}/>)}</div></div>
 <div style={{marginBottom:8}}><div style={{fontSize:10,color:C.muted,marginBottom:5}}>Skills</div><div style={{display:"flex",flexWrap:"wrap",gap:4}}>{selected.skills?.map(s=><Tag key={s} label={s}/>)}</div></div>
 <div><div style={{fontSize:10,color:C.muted,marginBottom:5}}>Tools</div><div style={{display:"flex",flexWrap:"wrap",gap:4}}>{selected.tools?.map(t=><Tag key={t} label={t} color={C.cyan}/>)}</div></div>
 </div>
 <div style={{background:C.card,borderRadius:12,padding:16}}>
 <div style={{fontSize:11,color:C.accent,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>AI Analysis</div>
 {selected.fitReason&&<div style={{fontSize:12,color:C.sub,marginBottom:8,lineHeight:1.6,fontStyle:"italic"}}>{selected.fitReason}</div>}
 {selected.strengths?.length>0&&<div style={{marginBottom:8}}><div style={{fontSize:10,color:C.green,marginBottom:4}}>STRENGTHS</div>{selected.strengths.map((s,i)=><div key={i} style={{fontSize:11,color:C.sub,paddingLeft:10,marginBottom:2}}> {s}</div>)}</div>}
 {selected.risks?.length>0&&<div><div style={{fontSize:10,color:C.red,marginBottom:4}}>RISKS</div>{selected.risks.map((r,i)=><div key={i} style={{fontSize:11,color:C.sub,paddingLeft:10,marginBottom:2}}> {r}</div>)}</div>}
 </div>
 </div>
 <div style={{marginTop:16,textAlign:"right"}}><Btn variant="danger" onClick={()=>deleteCandidate(selected.id)}> Remove Candidate</Btn></div>
 </div>
 </div>
 )}

 <h2 style={{fontSize:30,fontWeight:800,color:C.text,margin:"0 0 8px"}}>Talent Pool</h2>
 <p style={{fontSize:14,color:C.muted,margin:"0 0 20px"}}>{filtered.length} of {candidates.length} candidates</p>

 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:16,marginBottom:18}}>
 <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by name, skill, tool, role..."
 style={{width:"100%",background:C.surface,border:"1px solid "+C.border,borderRadius:10,padding:"9px 14px",color:C.text,fontSize:13,outline:"none",marginBottom:10,boxSizing:"border-box",fontFamily:"'Poppins', sans-serif"}}/>
 <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
 {[["Dept",filterDept,setFilterDept,["All",...DEPTS]],["Status",filterStatus,setFilterStatus,["All",...STATUSES]],["Level",filterLevel,setFilterLevel,["All",...LEVELS]],["Source",filterSource,setFilterSource,["All","Candidate Portal","HR Upload"]]].map(([label,val,setter,opts])=>(
 <div key={label} style={{display:"flex",alignItems:"center",gap:6}}>
 <span style={{fontSize:11,color:C.muted}}>{label}:</span>
 <select value={val} onChange={e=>setter(e.target.value)} style={{background:C.surface,color:C.text,border:"1px solid "+C.border,borderRadius:6,padding:"4px 10px",fontSize:11,fontFamily:"'Poppins', sans-serif"}}>
 {opts.map(o=><option key={o} value={o}>{o}</option>)}
 </select>
 </div>
 ))}
 <div style={{display:"flex",alignItems:"center",gap:6}}>
 <span style={{fontSize:11,color:C.muted}}>Min Exp:</span>
 <input type="number" min={0} max={20} value={minExp} onChange={e=>setMinExp(Number(e.target.value))} style={{background:C.surface,color:C.text,border:"1px solid "+C.border,borderRadius:6,padding:"4px 8px",fontSize:11,width:52,fontFamily:"'Poppins', sans-serif"}}/>
 <span style={{fontSize:11,color:C.muted}}>yrs</span>
 </div>
 </div>
 </div>

 {filtered.length===0
 ?<div style={{textAlign:"center",padding:60,color:C.muted}}><div style={{fontSize:40,marginBottom:12}}></div><div>No candidates match filters.</div></div>
 :(
 <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:14}}>
 {filtered.map(c=>{
 const sc=getDisplayScore(c);
 return(
 <div key={c.id} onClick={()=>setSelected(c)} style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:18,cursor:"pointer",borderLeft:"3px solid "+C.accent,transition:"all 0.15s"}}>
 {c.source==="Candidate Portal"&&<div style={{display:"inline-flex",alignItems:"center",gap:4,background:C.cyan+"20",color:C.cyan,border:"1px solid "+C.cyan+"40",borderRadius:5,padding:"2px 7px",fontSize:10,fontWeight:600,marginBottom:8}}> Portal</div>}
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
 <div style={{paddingRight:8,flex:1}}>
 <div style={{fontSize:14,fontWeight:700,color:C.text}}>{c.name}</div>
 <div style={{fontSize:11,color:C.sub}}>{c.currentTitle} · {c.totalYearsExp}y</div>
 {c.appliedRole&&<div style={{fontSize:10,color:C.accent,marginTop:2}}>→ {c.appliedRole}</div>}
 </div>
 <ScoreBadge score={sc} jdBased={c.jdFitScore!=null}/>
 </div>
 <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:10}}>
 {c.departments?.slice(0,2).map(d=><Tag key={d} label={d} color={C.purple}/>)}
 {c.skills?.slice(0,3).map(s=><Tag key={s} label={s}/>)}
 </div>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
 <StatusPill status={c.status}/>
 <select value={c.status} onChange={e=>{e.stopPropagation();updateStatus(c.id,e.target.value);}} onClick={e=>e.stopPropagation()}
 style={{background:C.surface,color:C.sub,border:"1px solid "+C.border,borderRadius:6,padding:"3px 8px",fontSize:11,cursor:"pointer",fontFamily:"'Poppins', sans-serif"}}>
 {STATUSES.map(s=><option key={s} value={s}>{s}</option>)}
 </select>
 </div>
 {c.uploadedBy&&c.source==="HR Upload"&&<div style={{fontSize:10,color:C.muted,marginTop:6}}>Added by <span style={{fontWeight:600,color:C.sub}}>{c.uploadedBy}</span></div>}
 </div>
 );
 })}
 </div>
 )}
 </div>
 );
}

// --- EXCEL MANAGER ------------------------------------------------------------
function ExcelManager({ candidates, showToast }) {
 const [sheets, setSheets] = useState([]);
 const [activeSheet, setActiveSheet] = useState(null);
 const [creating, setCreating] = useState(false);
 const [newSheetName, setNewSheetName] = useState("");
 const [selectedColumns, setSelectedColumns] = useState(["name","currentTitle","departments","seniority","totalYearsExp","skills","status","jdFitScore","appliedRole","email","phone","uploadedAt"]);
 const fileInputRef = useRef();

 const COLUMN_OPTIONS = [
 {key:"name",label:"Name"},{key:"email",label:"Email"},{key:"phone",label:"Phone"},
 {key:"location",label:"Location"},{key:"currentTitle",label:"Current Title"},{key:"currentCompany",label:"Company"},
 {key:"totalYearsExp",label:"Years Exp"},{key:"seniority",label:"Seniority"},{key:"departments",label:"Departments"},
 {key:"skills",label:"Skills"},{key:"tools",label:"Tools"},{key:"status",label:"Status"},
 {key:"jdFitScore",label:"JD Fit Score"},{key:"appliedRole",label:"Applied Role"},{key:"appliedDept",label:"Dept Applied"},
 {key:"noticePeriod",label:"Notice Period"},{key:"expectedCTC",label:"Expected CTC"},
 {key:"source",label:"Source"},{key:"uploadedAt",label:"Date Added"},
 ];

 useEffect(()=>{ dbGetAll("excel_sheets","acture_excel").then(s=>setSheets(s||[])); },[]);

 function getCellValue(candidate, key) {
 const v = candidate[key];
 if (v == null) return "";
 if (Array.isArray(v)) return v.join(", ");
 if (key === "uploadedAt") return new Date(v).toLocaleDateString("en-IN");
 if (key === "jdFitScore") return v != null ? v + "/100" : calcScore(candidate.scoring) + "/100 (AI)";
 return String(v);
 }

 function exportToCSV(sheetCandidates, cols, name) {
 const header = cols.map(k => COLUMN_OPTIONS.find(c=>c.key===k)?.label||k);
 const rows = sheetCandidates.map(c => cols.map(k => {
 const v = getCellValue(c,k);
 return '"'+v.replace(/"/g,'""')+'"';
 }));
 const csv = [header.join(","), ...rows.map(r=>r.join(","))].join("\n");
 const blob = new Blob([csv], {type:"text/csv"});
 const url = URL.createObjectURL(blob);
 const a = document.createElement("a"); a.href=url; a.download=(name||"candidates")+".csv"; a.click();
 URL.revokeObjectURL(url);
 showToast(" Exported "+sheetCandidates.length+" rows as CSV","success");
 }

 async function createSheet() {
 if (!newSheetName.trim()) return;
 const sheet = { id: uid(), name: newSheetName.trim(), createdAt: new Date().toISOString(), columns: selectedColumns, candidateIds: candidates.map(c=>c.id) };
 const updated = [...sheets, sheet];
 setSheets(updated);
 await dbSave("excel_sheets","acture_excel",sheet.id,sheet,updated);
 setActiveSheet(sheet); setCreating(false); setNewSheetName("");
 showToast(" Sheet '"+sheet.name+"' created with "+candidates.length+" candidates","success");
 }

 function handleFileUpload(e) {
 const file = e.target.files[0]; if (!file) return;
 const reader = new FileReader();
 reader.onload = async (ev) => {
 const text = ev.target.result;
 const lines = text.split("\n").filter(l=>l.trim());
 if (lines.length < 2) { showToast("CSV is empty or invalid","error"); return; }
 const headers = lines[0].split(",").map(h=>h.replace(/"/g,"").trim().toLowerCase());
 const rows = lines.slice(1).map(line => {
 const vals = line.match(/(".*?"|[^,]+)/g) || [];
 const obj = {};
 headers.forEach((h,i) => { obj[h] = (vals[i]||"").replace(/"/g,"").trim(); });
 return obj;
 });
 const sheet = { id: uid(), name: file.name.replace(/\.[^.]+$/,""), createdAt: new Date().toISOString(), columns: headers, importedRows: rows, isImported: true };
 const updated = [...sheets, sheet];
 setSheets(updated);
 await dbSave("excel_sheets","acture_excel",sheet.id,sheet,updated);
 setActiveSheet(sheet);
 showToast(" Imported "+rows.length+" rows from "+file.name,"success");
 };
 reader.readAsText(file);
 e.target.value = "";
 }

 async function deleteSheet(id) {
 const remaining = sheets.filter(s=>s.id!==id);
 setSheets(remaining);
 await dbDelete("excel_sheets","acture_excel",id,remaining);
 if (activeSheet?.id===id) setActiveSheet(null);
 showToast("Sheet removed","success");
 }

 const activeSheetCandidates = activeSheet?.isImported ? null : candidates.filter(c => activeSheet?.candidateIds?.includes(c.id));

 return (
 <div>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20}}>
 <div>
 <h2 style={{fontSize:30,fontWeight:800,color:C.text,margin:0}}>Excel Manager</h2>
 <p style={{fontSize:14,color:C.muted,margin:"6px 0 0"}}>Create, export & import candidate spreadsheets</p>
 </div>
 <div style={{display:"flex",gap:10}}>
 <Btn variant="secondary" onClick={()=>fileInputRef.current?.click()}> Import CSV</Btn>
 <input ref={fileInputRef} type="file" accept=".csv" style={{display:"none"}} onChange={handleFileUpload}/>
 <Btn onClick={()=>{setCreating(true);setActiveSheet(null);}}>+ New Sheet</Btn>
 </div>
 </div>

 {creating&&(
 <div style={{background:C.card,border:"1px solid "+C.accent+"40",borderRadius:16,padding:24,marginBottom:24}}>
 <div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:16}}>Create New Candidate Sheet</div>
 <div style={{marginBottom:16}}>
 <Input label="Sheet Name" value={newSheetName} onChange={setNewSheetName} placeholder="e.g. Q1 2025 Candidates, SEO Applicants..."/>
 </div>
 <div style={{marginBottom:16}}>
 <div style={{fontSize:13,color:C.muted,marginBottom:10}}>Select Columns to Include</div>
 <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
 {COLUMN_OPTIONS.map(col=>(
 <button key={col.key} onClick={()=>setSelectedColumns(prev=>prev.includes(col.key)?prev.filter(k=>k!==col.key):[...prev,col.key])}
 style={{background:selectedColumns.includes(col.key)?C.accent+"25":C.surface,color:selectedColumns.includes(col.key)?C.accent:C.sub,border:"1px solid "+(selectedColumns.includes(col.key)?C.accent+"60":C.border),borderRadius:6,padding:"5px 12px",fontSize:12,cursor:"pointer",fontWeight:500,fontFamily:"'Poppins', sans-serif"}}>
 {selectedColumns.includes(col.key)?" ":""}{col.label}
 </button>
 ))}
 </div>
 </div>
 <div style={{fontSize:12,color:C.muted,marginBottom:16}}>This will include all {candidates.length} current candidates.</div>
 <div style={{display:"flex",gap:10}}>
 <Btn onClick={createSheet} disabled={!newSheetName.trim()}> Create Sheet</Btn>
 <Btn variant="secondary" onClick={()=>{setCreating(false);setNewSheetName("");}}>Cancel</Btn>
 </div>
 </div>
 )}

 <div style={{display:"grid",gridTemplateColumns:activeSheet?"240px 1fr":"repeat(auto-fill,minmax(260px,1fr))",gap:16}}>
 <div style={activeSheet?{display:"flex",flexDirection:"column",gap:10}:undefined}>
 {sheets.length===0&&!creating&&(
 <div style={{textAlign:"center",padding:60,color:C.muted,gridColumn:"1/-1"}}>
 <div style={{fontSize:48,marginBottom:12}}></div>
 <div style={{fontSize:15,marginBottom:8}}>No sheets yet.</div>
 <div style={{fontSize:13}}>Create a new sheet or import a CSV file.</div>
 </div>
 )}
 {sheets.map(s=>(
 <div key={s.id} onClick={()=>setActiveSheet(activeSheet?.id===s.id?null:s)}
 style={{background:activeSheet?.id===s.id?C.accent+"15":C.card,border:"1px solid "+(activeSheet?.id===s.id?C.accent+"60":C.border),borderRadius:12,padding:"16px 18px",cursor:"pointer",transition:"all 0.15s"}}>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
 <div>
 <div style={{fontSize:14,fontWeight:700,color:activeSheet?.id===s.id?C.accent:C.text}}>{s.isImported?"":""} {s.name}</div>
 <div style={{fontSize:11,color:C.muted,marginTop:3}}>{s.isImported?s.importedRows?.length+" imported rows":s.candidateIds?.length+" candidates"}</div>
 <div style={{fontSize:10,color:C.muted}}>{new Date(s.createdAt).toLocaleDateString("en-IN")}</div>
 </div>
 <button onClick={e=>{e.stopPropagation();deleteSheet(s.id);}} style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:14}}></button>
 </div>
 </div>
 ))}
 </div>

 {activeSheet&&(
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:16,padding:20,overflow:"auto"}}>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
 <div>
 <div style={{fontSize:16,fontWeight:700,color:C.text}}>{activeSheet.name}</div>
 <div style={{fontSize:12,color:C.muted}}>{activeSheet.isImported?activeSheet.importedRows?.length:activeSheetCandidates?.length} rows · {activeSheet.columns?.length} columns</div>
 </div>
 {!activeSheet.isImported&&(
 <Btn variant="success" onClick={()=>exportToCSV(activeSheetCandidates,activeSheet.columns,activeSheet.name)}> Export CSV</Btn>
 )}
 </div>
 <div style={{overflowX:"auto"}}>
 <table style={{width:"100%",borderCollapse:"collapse",fontSize:12,fontFamily:"'Poppins', sans-serif"}}>
 <thead>
 <tr style={{background:C.surface}}>
 <th style={{padding:"8px 12px",textAlign:"left",color:C.muted,fontWeight:600,borderBottom:"1px solid "+C.border,whiteSpace:"nowrap"}}>#</th>
 {activeSheet.columns.map(k=>(
 <th key={k} style={{padding:"8px 12px",textAlign:"left",color:C.muted,fontWeight:600,borderBottom:"1px solid "+C.border,whiteSpace:"nowrap"}}>
 {activeSheet.isImported?k:COLUMN_OPTIONS.find(c=>c.key===k)?.label||k}
 </th>
 ))}
 </tr>
 </thead>
 <tbody>
 {activeSheet.isImported
 ? activeSheet.importedRows?.slice(0,100).map((row,i)=>(
 <tr key={i} style={{borderBottom:"1px solid "+C.border+"50",background:i%2===0?"transparent":C.surface+"40"}}>
 <td style={{padding:"7px 12px",color:C.muted}}>{i+1}</td>
 {activeSheet.columns.map(k=>(
 <td key={k} style={{padding:"7px 12px",color:C.sub,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row[k]||""}</td>
 ))}
 </tr>
 ))
 : activeSheetCandidates?.map((c,i)=>(
 <tr key={c.id} style={{borderBottom:"1px solid "+C.border+"50",background:i%2===0?"transparent":C.surface+"40"}}>
 <td style={{padding:"7px 12px",color:C.muted}}>{i+1}</td>
 {activeSheet.columns.map(k=>(
 <td key={k} style={{padding:"7px 12px",color:C.sub,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
 {k==="jdFitScore"?<ScoreBadge score={getDisplayScore(c)} jdBased={c.jdFitScore!=null}/>:getCellValue(c,k)}
 </td>
 ))}
 </tr>
 ))
 }
 </tbody>
 </table>
 {!activeSheet.isImported&&activeSheetCandidates?.length===0&&(
 <div style={{textAlign:"center",padding:32,color:C.muted}}>No candidates in this sheet.</div>
 )}
 </div>
 </div>
 )}
 </div>
 </div>
 );
}

// --- REQUISITIONS -------------------------------------------------------------
function Requisitions({ jobs, setJobs, showToast, currentUser }) {
 const defaultSubmittedBy = currentUser ? currentUser.name : "";
 const blank={title:"",department:"",employmentType:"",ctcRange:"",reportingTo:"",urgency:"Planned",triggerType:"",justification:"",submittedBy:defaultSubmittedBy,status:"Active"};
 const [showForm,setShowForm]=useState(false);
 const [form,setForm]=useState({...blank});
 const [saving,setSaving]=useState(false);
 function set(key){return val=>setForm(prev=>({...prev,[key]:val}));}

 function openForm(){ setForm({...blank, submittedBy: currentUser ? currentUser.name : ""}); setShowForm(true); }

 async function save(){
 if(!form.title||!form.department)return;
 setSaving(true);
 const job={...form, submittedBy: form.submittedBy || (currentUser ? currentUser.name : "HR Staff"), id:uid(), createdAt:new Date().toISOString()};
 const updated=[...jobs,job];
 setJobs(updated);
 await dbSave("jobs","acture_jobs",job.id,job,updated);
 setSaving(false);setShowForm(false);setForm({...blank});
 showToast(" HRF saved successfully","success");
 }

 async function remove(id){ const remaining=jobs.filter(j=>j.id!==id); setJobs(remaining); await dbDelete("jobs","acture_jobs",id,remaining); }
 const getInitials = (name) => name ? name.split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2) : "HR";

 return (
 <div>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20}}>
 <div>
 <h2 style={{fontSize:30,fontWeight:800,color:C.text,margin:0}}>Job Requisitions (HRF)</h2>
 <p style={{fontSize:14,color:C.muted,margin:"6px 0 0"}}>Phase 1 SOP · Submit hiring requests</p>
 </div>
 <div style={{display:"flex",alignItems:"center",gap:12}}>
 {currentUser&&(
 <div style={{display:"flex",alignItems:"center",gap:8,background:C.card,border:"1px solid "+C.border,borderRadius:10,padding:"7px 14px"}}>
 <div style={{width:28,height:28,borderRadius:"50%",background:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff"}}>{currentUser.avatar||getInitials(currentUser.name)}</div>
 <div>
 <div style={{fontSize:10,color:C.muted,lineHeight:1}}>Submitting as</div>
 <div style={{fontSize:13,fontWeight:700,color:C.text,lineHeight:1.4}}>{currentUser.name}</div>
 </div>
 </div>
 )}
 <Btn onClick={openForm}>+ New Requisition</Btn>
 </div>
 </div>
 {showForm&&(
 <div style={{background:C.card,border:"1px solid "+C.accent+"40",borderRadius:16,padding:24,marginBottom:24}}>
 <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:18}}>
 <div style={{fontSize:14,fontWeight:700,color:C.text}}>Hiring Requisition Form</div>
 {currentUser&&(
 <div style={{display:"flex",alignItems:"center",gap:6,background:C.accent+"12",border:"1px solid "+C.accent+"30",borderRadius:8,padding:"5px 12px"}}>
 <div style={{width:22,height:22,borderRadius:"50%",background:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:700,color:"#fff"}}>{currentUser.avatar||getInitials(currentUser.name)}</div>
 <span style={{fontSize:12,color:C.accent,fontWeight:600}}>Submitted by {currentUser.name} · {currentUser.role}</span>
 </div>
 )}
 </div>
 <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
 <Input label="Role Title" value={form.title} onChange={set("title")} placeholder="e.g. SEO Executive" required/>
 <Input label="CTC Range" value={form.ctcRange} onChange={set("ctcRange")} placeholder="e.g. 4-6 LPA"/>
 <Input label="Reporting To" value={form.reportingTo} onChange={set("reportingTo")} placeholder="e.g. Head of SEO"/>
 <Input label="Submitted By" value={form.submittedBy} onChange={set("submittedBy")} placeholder="HR Name"/>
 <Select label="Department" value={form.department} onChange={set("department")} options={DEPTS} required/>
 <Select label="Employment Type" value={form.employmentType} onChange={set("employmentType")} options={EMP_TYPES}/>
 <Select label="Urgency" value={form.urgency} onChange={set("urgency")} options={["Immediate","Planned"]}/>
 <Select label="Trigger Type" value={form.triggerType} onChange={set("triggerType")} options={TRIGGERS}/>
 <Select label="Status" value={form.status} onChange={set("status")} options={["Active","On Hold","Closed"]}/>
 </div>
 <div style={{marginTop:14}}><Input label="Required Skills" value={form.skills||""} onChange={set("skills")} placeholder="e.g. SEO, Shopify, GA4..."/></div>
 <div style={{marginTop:14}}><Textarea label="Business Justification" value={form.justification} onChange={set("justification")} placeholder="Why is this role needed?" rows={4}/></div>
 <div style={{marginTop:18,display:"flex",gap:10}}>
 <Btn onClick={save} disabled={!form.title||!form.department||saving}>{saving?" Saving...":" Save Requisition"}</Btn>
 <Btn variant="secondary" onClick={()=>{setShowForm(false);setForm({...blank});}}>Cancel</Btn>
 </div>
 </div>
 )}
 {jobs.length===0?<div style={{textAlign:"center",padding:60,color:C.muted}}><div style={{fontSize:40,marginBottom:12}}></div><div>No requisitions yet.</div></div>:(
 <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(310px,1fr))",gap:14}}>
 {jobs.map(j=>(
 <div key={j.id} style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:20,borderTop:"3px solid "+C.accent}}>
 <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
 <div>
 <div style={{fontSize:14,fontWeight:700,color:C.text}}>{j.title}</div>
 <div style={{fontSize:11,color:C.sub}}>{j.department} · {j.employmentType}</div>
 </div>
 <button onClick={()=>remove(j.id)} style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:16}}></button>
 </div>
 <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
 <Tag label={j.status||"Active"} color={C.accent}/>
 {j.urgency&&<Tag label={j.urgency} color={C.accent}/>}
 {j.triggerType&&<Tag label={j.triggerType} color={C.accent}/>}
 </div>
 {j.ctcRange&&<div style={{fontSize:11,color:C.muted,marginBottom:3}}><span style={{color:C.sub}}>CTC: </span>{j.ctcRange}</div>}
 {j.reportingTo&&<div style={{fontSize:11,color:C.muted,marginBottom:3}}><span style={{color:C.sub}}>Reporting To: </span>{j.reportingTo}</div>}
 {j.submittedBy&&(
 <div style={{display:"flex",alignItems:"center",gap:6,marginTop:10,paddingTop:10,borderTop:"1px solid "+C.border}}>
 <div style={{width:22,height:22,borderRadius:"50%",background:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:700,color:"#fff",flexShrink:0}}>{getInitials(j.submittedBy)}</div>
 <div><div style={{fontSize:10,color:C.muted,lineHeight:1}}>Submitted by</div><div style={{fontSize:12,fontWeight:700,color:C.text}}>{j.submittedBy}</div></div>
 {j.createdAt&&<div style={{marginLeft:"auto",fontSize:10,color:C.muted}}>{new Date(j.createdAt).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})}</div>}
 </div>
 )}
 {j.justification&&<div style={{fontSize:11,color:C.muted,marginTop:8,borderTop:"1px solid "+C.border,paddingTop:8,lineHeight:1.5}}>{j.justification}</div>}
 </div>
 ))}
 </div>
 )}
 </div>
 );
}

// --- JD BUILDER ---------------------------------------------------------------
function JDBuilder({ jdDocs, setJdDocs, showToast }) {
 const blank={title:"",department:"",experience:"",employmentType:"",location:"",ctcRange:"",skills:"",tone:"Professional",content:""};
 const [form,setForm]=useState({...blank});
 const [generating,setGenerating]=useState(false);
 const [editing,setEditing]=useState(false);
 const [selected,setSelected]=useState(null);
 function set(key){return val=>setForm(prev=>({...prev,[key]:val}));}

 async function generate(){
 if(!form.title||!form.department)return;
 setGenerating(true); setForm(prev=>({...prev,content:""}));
 try{ await generateJD(form.title,form.department,form.experience,form.skills,form.tone,(partial)=>setForm(prev=>({...prev,content:partial}))); }
 catch(err){showToast("JD generation failed: "+err.message,"error");}
 setGenerating(false);
 }

 async function saveDoc(){
 if(!form.title||!form.content)return;
 const doc={...form,id:uid(),createdAt:new Date().toISOString()};
 const updated=[...jdDocs,doc];
 setJdDocs(updated);
 await dbSave("jd_documents","acture_jds",doc.id,doc,updated);
 showToast(" JD saved: "+doc.title,"success");
 setForm({...blank});setEditing(false);
 }

 async function removeDoc(id){
 const remaining=jdDocs.filter(d=>d.id!==id);
 setJdDocs(remaining);
 await dbDelete("jd_documents","acture_jds",id,remaining);
 setSelected(null);
 }

 return (
 <div>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20}}>
 <div><h2 style={{fontSize:30,fontWeight:800,color:C.text,margin:0}}>JD Builder</h2><p style={{fontSize:14,color:C.muted,margin:"6px 0 0"}}>AI-generated Job Descriptions · used for JD-based fit scoring</p></div>
 <Btn onClick={()=>{setEditing(true);setSelected(null);setForm({...blank});}}>+ Create New JD</Btn>
 </div>
 {jdDocs.length>0&&(
 <div style={{background:C.accent+"10",border:"1px solid "+C.accent+"30",borderRadius:10,padding:"10px 16px",marginBottom:16,fontSize:12,color:C.accent}}>
 These {jdDocs.length} JDs are visible to candidates on the public portal for role selection. Candidates' resumes are scored against the selected JD.
 </div>
 )}
 {editing&&(
 <div style={{background:C.card,border:"1px solid "+C.accent+"40",borderRadius:16,padding:24,marginBottom:24}}>
 <div style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:18}}>New Job Description</div>
 <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
 <Input label="Role Title" value={form.title} onChange={set("title")} placeholder="e.g. Senior SEO Strategist" required/>
 <Select label="Department" value={form.department} onChange={set("department")} options={DEPTS} required/>
 <Input label="Experience Required" value={form.experience} onChange={set("experience")} placeholder="e.g. 3-5 years"/>
 <Select label="Employment Type" value={form.employmentType} onChange={set("employmentType")} options={EMP_TYPES}/>
 <Input label="Location" value={form.location} onChange={set("location")} placeholder="Mumbai / Remote / Hybrid"/>
 <Input label="CTC Range" value={form.ctcRange} onChange={set("ctcRange")} placeholder="e.g. 8-12 LPA"/>
 <Select label="Writing Tone" value={form.tone} onChange={set("tone")} options={["Professional","Energetic & Startup","Formal & Corporate","Friendly & Inclusive"]}/>
 </div>
 <div style={{marginBottom:14}}><Input label="Key Skills (comma separated)" value={form.skills} onChange={set("skills")} placeholder="SEO, Shopify, GA4, Ahrefs..."/></div>
 <div style={{display:"flex",gap:10,marginBottom:14,alignItems:"center"}}>
 <Btn onClick={generate} disabled={!form.title||!form.department||generating}>{generating?" Writing JD...":" Generate with AI"}</Btn>
 <span style={{fontSize:12,color:C.muted}}>or write manually below</span>
 </div>
 <Textarea label="Job Description Content" value={form.content} onChange={set("content")} placeholder="AI-generated or write manually here..." rows={14}/>
 <div style={{marginTop:16,display:"flex",gap:10,flexWrap:"wrap"}}>
 <Btn onClick={saveDoc} disabled={!form.title||!form.content}> Save JD</Btn>
 {form.title&&form.content&&<Btn variant="success" onClick={()=>downloadPDF(form)}> Preview PDF</Btn>}
 {form.title&&form.content&&<Btn variant="secondary" onClick={()=>downloadDOC(form)}> Download DOC</Btn>}
 <Btn variant="ghost" onClick={()=>{setEditing(false);setForm({...blank});}}>Cancel</Btn>
 </div>
 </div>
 )}
 {selected&&(
 <div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.88)",display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={()=>setSelected(null)}>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:20,width:"100%",maxWidth:760,maxHeight:"92vh",overflow:"auto",padding:28}} onClick={e=>e.stopPropagation()}>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
 <div><div style={{fontSize:20,fontWeight:800,color:C.text}}>{selected.title}</div><div style={{fontSize:12,color:C.sub}}>{selected.department} · {selected.experience} · {selected.employmentType}</div></div>
 <div style={{display:"flex",gap:8}}>
 <Btn variant="success" small onClick={()=>downloadPDF(selected)}> PDF</Btn>
 <Btn variant="secondary" small onClick={()=>downloadDOC(selected)}> DOC</Btn>
 <Btn variant="danger" small onClick={()=>removeDoc(selected.id)}></Btn>
 <Btn variant="ghost" small onClick={()=>setSelected(null)}></Btn>
 </div>
 </div>
 <div style={{whiteSpace:"pre-wrap",fontSize:14,color:C.sub,lineHeight:1.8,background:C.card,borderRadius:12,padding:20}}>{selected.content}</div>
 </div>
 </div>
 )}
 {jdDocs.length===0&&!editing?<div style={{textAlign:"center",padding:60,color:C.muted}}><div style={{fontSize:40,marginBottom:12}}></div><div>No JDs yet. Click "Create New JD" to start.</div></div>:(
 <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(295px,1fr))",gap:14}}>
 {jdDocs.map(d=>(
 <div key={d.id} style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:20,cursor:"pointer"}} onClick={()=>setSelected(d)}>
 <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
 <div><div style={{fontSize:14,fontWeight:700,color:C.text}}>{d.title}</div><div style={{fontSize:11,color:C.sub}}>{d.department} · {d.experience}</div></div>
 <Tag label={d.employmentType||"Full-time"} color={C.purple}/>
 </div>
 <div style={{fontSize:12,color:C.muted,lineHeight:1.5,marginBottom:12}}>{d.content?.substring(0,110)}...</div>
 <div style={{display:"flex",gap:8}} onClick={e=>e.stopPropagation()}>
 <Btn variant="success" small onClick={()=>downloadPDF(d)}> PDF</Btn>
 <Btn variant="secondary" small onClick={()=>downloadDOC(d)}> DOC</Btn>
 <Btn variant="danger" small onClick={()=>removeDoc(d.id)}></Btn>
 </div>
 </div>
 ))}
 </div>
 )}
 </div>
 );
}

// --- INTERVIEW FEEDBACK -------------------------------------------------------
function InterviewFeedback({ candidates, feedbacks, setFeedbacks, showToast }) {
 const blank={candidateId:"",round:"Round 1 – Functional",interviewerName:"",interviewerRole:"HR",date:new Date().toISOString().split("T")[0],skillRating:"",commRating:"",cultureRating:"",techRating:"",overallRating:"",recommendation:"",strengths:"",areasToImprove:"",notes:"",aiSummary:""};
 const [showForm,setShowForm]=useState(false);
 const [form,setForm]=useState({...blank});
 const [aiLoading,setAiLoading]=useState(false);
 const [aiText,setAiText]=useState("");
 const [filter,setFilter]=useState("All");
 function set(key){return val=>setForm(prev=>({...prev,[key]:val}));}
 const cand=candidates.find(c=>c.id===form.candidateId);
 function ratingColor(){ return C.accent; }
 function Stars({value,onChange}){return(<div style={{display:"flex",gap:6}}>{[1,2,3,4,5].map(n=>(<button key={n} onClick={()=>onChange(String(n))} style={{width:36,height:36,borderRadius:8,border:"1px solid "+(parseInt(value)>=n?ratingColor():C.border),background:parseInt(value)>=n?ratingColor()+"30":"transparent",color:parseInt(value)>=n?ratingColor():C.muted,fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:"'Poppins', sans-serif"}}>{n}</button>))}</div>);}
 async function genSummary(){
 if(!form.strengths&&!form.notes)return;
 setAiLoading(true);
 try{ const txt=await callClaude([{role:"user",content:"Summarize this interview feedback in 2-3 professional sentences.\nCandidate: "+(cand?.name||"Unknown")+"\nRound: "+form.round+"\nStrengths: "+form.strengths+"\nAreas to Improve: "+form.areasToImprove+"\nOverall: "+form.overallRating+"/5\nRecommendation: "+form.recommendation+"\nNotes: "+form.notes}]); setAiText(txt); }
 catch(err){showToast("AI summary failed: "+err.message,"error");}
 setAiLoading(false);
 }
 async function saveFeedback(){
 if(!form.candidateId||!form.interviewerName)return;
 const fb={...form,aiSummary:aiText,id:uid(),createdAt:new Date().toISOString()};
 const updated=[...feedbacks,fb];
 setFeedbacks(updated);
 await dbSave("feedbacks","acture_feedbacks",fb.id,fb,updated);
 showToast(" Feedback saved","success");
 setShowForm(false);setForm({...blank});setAiText("");
 }
 async function removeFeedback(id){ const remaining=feedbacks.filter(f=>f.id!==id); setFeedbacks(remaining); await dbDelete("feedbacks","acture_feedbacks",id,remaining); }
 const filtered=feedbacks.filter(f=>filter==="All"||f.round===filter);
 return (
 <div>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20}}>
 <div><h2 style={{fontSize:30,fontWeight:800,color:C.text,margin:0}}>Interview Feedback</h2><p style={{fontSize:14,color:C.muted,margin:"6px 0 0"}}>Phase 5 SOP · Written record mandatory within 24h</p></div>
 <Btn onClick={()=>setShowForm(true)}>+ Add Feedback</Btn>
 </div>
 {showForm&&(
 <div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.88)",display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={()=>setShowForm(false)}>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:20,width:"100%",maxWidth:760,maxHeight:"92vh",overflow:"auto",padding:28,fontFamily:"'Poppins', sans-serif"}} onClick={e=>e.stopPropagation()}>
 <div style={{fontSize:18,fontWeight:800,color:C.text,marginBottom:4}}>Interview Feedback Form</div>
 <div style={{fontSize:12,color:C.sub,background:C.red+"10",border:"1px solid "+C.red+"25",borderRadius:8,padding:"8px 12px",marginBottom:20}}> SOP Phase 5: Written feedback mandatory within 24h.</div>
 <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
 <div>
 <div style={{fontSize:11,color:C.muted,marginBottom:5}}>Candidate <span style={{color:C.accent}}>*</span></div>
 <select value={form.candidateId} onChange={e=>set("candidateId")(e.target.value)} style={{width:"100%",background:C.surface,color:C.text,border:"1px solid "+C.border,borderRadius:8,padding:"9px 12px",fontSize:13,boxSizing:"border-box",fontFamily:"'Poppins', sans-serif"}}>
 <option value="">Select candidate...</option>
 {candidates.map(c=><option key={c.id} value={c.id}>{c.name} — {c.currentTitle}</option>)}
 </select>
 </div>
 <Select label="Interview Round" value={form.round} onChange={set("round")} options={ROUNDS}/>
 <Input label="Interviewer Name" value={form.interviewerName} onChange={set("interviewerName")} placeholder="Your full name" required/>
 <Select label="Interviewer Role" value={form.interviewerRole} onChange={set("interviewerRole")} options={["HR","Team Lead","Hiring Manager","COO","Technical Expert"]}/>
 <Input label="Interview Date" value={form.date} onChange={set("date")} type="date"/>
 <Select label="Recommendation" value={form.recommendation} onChange={set("recommendation")} options={["Hire","Hold","Reject"]}/>
 </div>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:18,marginBottom:16}}>
 <div style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:14}}>Ratings (1 = Poor · 5 = Excellent)</div>
 <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
 {[["Skill Depth",form.skillRating,set("skillRating")],["Communication",form.commRating,set("commRating")],["Culture Fit",form.cultureRating,set("cultureRating")],["Technical",form.techRating,set("techRating")]].map(([label,val,setter])=>(<div key={label}><div style={{fontSize:11,color:C.muted,marginBottom:8}}>{label}</div><Stars value={val} onChange={setter}/></div>))}
 </div>
 <div>
 <div style={{fontSize:11,color:C.muted,marginBottom:8}}>Overall Rating</div>
 <div style={{display:"flex",gap:6,alignItems:"center"}}>
 {[1,2,3,4,5].map(n=>(<button key={n} onClick={()=>set("overallRating")(String(n))} style={{width:44,height:44,borderRadius:10,border:"2px solid "+(parseInt(form.overallRating)>=n?ratingColor():C.border),background:parseInt(form.overallRating)>=n?ratingColor()+"30":"transparent",color:parseInt(form.overallRating)>=n?ratingColor():C.muted,fontWeight:800,fontSize:16,cursor:"pointer",fontFamily:"'Poppins', sans-serif"}}>{n}</button>))}
 {form.overallRating&&<span style={{fontSize:14,color:ratingColor(),fontWeight:700,marginLeft:8}}>{["","Poor","Below Average","Average","Good","Excellent"][parseInt(form.overallRating)]}</span>}
 </div>
 </div>
 </div>
 <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
 <Textarea label="Strengths Observed" value={form.strengths} onChange={set("strengths")} placeholder="What stood out positively?" rows={4}/>
 <Textarea label="Areas of Improvement" value={form.areasToImprove} onChange={set("areasToImprove")} placeholder="What gaps were observed?" rows={4}/>
 </div>
 <div style={{marginBottom:16}}><Textarea label="Detailed Notes" value={form.notes} onChange={set("notes")} placeholder="Additional observations..." rows={4}/></div>
 <div style={{background:C.purple+"12",border:"1px solid "+C.purple+"30",borderRadius:12,padding:16,marginBottom:16}}>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
 <div style={{fontSize:12,fontWeight:700,color:C.purple}}> AI Summary Generator</div>
 <Btn variant="purple" small onClick={genSummary} disabled={aiLoading||(!form.strengths&&!form.notes)}>{aiLoading?"Writing...":" Generate"}</Btn>
 </div>
 {aiText?<div style={{fontSize:12,color:C.sub,lineHeight:1.7}}>{aiText}</div>:<div style={{fontSize:11,color:C.muted}}>Fill in strengths/notes above, then click Generate.</div>}
 </div>
 <div style={{display:"flex",gap:10}}>
 <Btn onClick={saveFeedback} disabled={!form.candidateId||!form.interviewerName}> Save Feedback</Btn>
 <Btn variant="secondary" onClick={()=>{setShowForm(false);setForm({...blank});setAiText("");}}>Cancel</Btn>
 </div>
 </div>
 </div>
 )}
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:12,padding:12,marginBottom:18,display:"flex",gap:6,flexWrap:"wrap"}}>
 {["All",...ROUNDS].map(r=>(<button key={r} onClick={()=>setFilter(r)} style={{background:filter===r?C.accent+"18":"transparent",border:filter===r?"1px solid "+C.accent+"40":"1px solid "+C.border,color:filter===r?C.accent:C.sub,borderRadius:8,padding:"5px 12px",fontSize:11,cursor:"pointer",fontWeight:600,fontFamily:"'Poppins', sans-serif"}}>{r}</button>))}
 </div>
 {filtered.length===0?<div style={{textAlign:"center",padding:60,color:C.muted}}><div style={{fontSize:40,marginBottom:12}}></div><div>No feedback yet.</div></div>:(
 <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:14}}>
 {filtered.map(fb=>{const c=candidates.find(x=>x.id===fb.candidateId);const ov=parseInt(fb.overallRating)||0;return(
 <div key={fb.id} style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:20,borderTop:"3px solid "+C.accent}}>
 <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}>
 <div><div style={{fontSize:14,fontWeight:700,color:C.text}}>{c?.name||"Unknown"}</div><div style={{fontSize:11,color:C.sub}}>{fb.round} · {fb.date}</div><div style={{fontSize:11,color:C.muted}}>by {fb.interviewerName} ({fb.interviewerRole})</div></div>
 <div style={{textAlign:"right"}}><div style={{fontSize:22,fontWeight:800,color:C.accent}}>{ov}/5</div><Tag label={fb.recommendation||"Pending"} color={C.accent}/></div>
 </div>
 {fb.strengths&&<div style={{marginBottom:8}}><div style={{fontSize:10,color:C.green,marginBottom:3}}>STRENGTHS</div><div style={{fontSize:11,color:C.sub,lineHeight:1.5}}>{fb.strengths}</div></div>}
 {fb.aiSummary&&<div style={{background:C.purple+"12",borderRadius:8,padding:"8px 10px",marginBottom:8}}><div style={{fontSize:10,color:C.purple,marginBottom:3}}>AI SUMMARY</div><div style={{fontSize:11,color:C.sub,lineHeight:1.5,fontStyle:"italic"}}>{fb.aiSummary}</div></div>}
 <div style={{marginTop:10,textAlign:"right"}}><Btn variant="danger" small onClick={()=>removeFeedback(fb.id)}></Btn></div>
 </div>
 );})}
 </div>
 )}
 </div>
 );
}

// --- SOP PIPELINE -------------------------------------------------------------
function SOPPipeline({ candidates }) {
 const [expanded,setExpanded]=useState(null);
 const statusCounts=STATUSES.map(s=>({s,n:candidates.filter(c=>c.status===s).length}));
 const phases=[
 {id:1,name:"Phase 1: Hiring Requirement Initiation",sla:"2 Working Days",owner:"HR → COO",steps:["Identify trigger","Raise HRF","HRF reviewed by Hiring Manager","COO approval","System auto-emails CEO/COO"],rules:["No verbal approvals","No 'keep resumes ready' triggers","HR can pause if trigger unclear"]},
 {id:2,name:"Phase 2: Job Description Creation",sla:"1 Working Day",owner:"HR",steps:["Create JD using JD Builder","JD reviewed by HM","COO approval before posting","Download as PDF/DOC"],rules:["JD must follow Acture format","COO + HM approval mandatory"]},
 {id:3,name:"Phase 3: Sourcing & Job Posting",sla:"Active",owner:"HR",steps:["Post on LinkedIn, Naukri, Internshala, Indeed","Activate employee referrals","Log platform, posting date, link in tracker"],rules:["All platforms enabled per role","Tracker updated per platform"]},
 {id:4,name:"Phase 4: Candidate Tracking & Screening",sla:"3 Working Days",owner:"HR",steps:["Log all candidates in Talent Pool","Resume screen: Skill, Experience, Portfolio","HR Screening Call (15-20 min)","Outcome: Shortlist / Hold / Reject"],rules:["No candidate lost without documentation","Rejection reason mandatory","Single source of truth"]},
 {id:5,name:"Phase 5: Interview Process",sla:"Feedback within 24h",owner:"HR + HM + COO",steps:["Round 1 – Functional: HM/Team Lead","Round 2 – Culture & Alignment: COO/HM","HR coordinates scheduling","Feedback form submitted within 24h"],rules:[" No verbal feedback — all written in system","24-hour feedback SLA non-negotiable","Calendar invite mandatory"]},
 ];
 return (
 <div>
 <h2 style={{fontSize:30,fontWeight:800,color:C.text,margin:"0 0 8px"}}>SOP Hiring Pipeline</h2>
 <p style={{fontSize:14,color:C.muted,margin:"0 0 20px"}}>Acture Media Standard Operating Procedure · Phases 1–5</p>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:20,marginBottom:20}}>
 <div style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:12}}>Live Candidate Pipeline</div>
 <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>{statusCounts.map(({s,n})=>(<div key={s} style={{background:C.surface,border:"1px solid "+C.border,borderRadius:10,padding:"8px 12px",textAlign:"center",minWidth:68}}><div style={{fontSize:18,fontWeight:800,color:C.text}}>{n}</div><div style={{fontSize:10,color:C.muted}}>{s}</div></div>))}</div>
 </div>
 {phases.map(p=>(<div key={p.id} style={{background:C.card,border:"1px solid "+(expanded===p.id?C.accent+"60":C.border),borderRadius:14,marginBottom:12,overflow:"hidden"}}>
 <div onClick={()=>setExpanded(expanded===p.id?null:p.id)} style={{padding:"16px 20px",cursor:"pointer",display:"flex",alignItems:"center",gap:14,background:expanded===p.id?C.accent+"08":"transparent"}}>
 <div style={{width:32,height:32,borderRadius:"50%",background:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:800,color:"#fff",flexShrink:0}}>{p.id}</div>
 <div style={{flex:1}}><div style={{fontSize:13,fontWeight:700,color:C.text}}>{p.name}</div><div style={{fontSize:11,color:C.muted}}>Owner: {p.owner} · SLA: {p.sla}</div></div>
 <div style={{background:C.accent+"20",color:C.accent,border:"1px solid "+C.accent+"40",borderRadius:6,padding:"3px 10px",fontSize:11,fontWeight:600}}>SLA: {p.sla}</div>
 <span style={{color:C.muted}}>{expanded===p.id?"▲":"▼"}</span>
 </div>
 {expanded===p.id&&(<div style={{padding:"0 20px 20px",borderTop:"1px solid "+C.border}}>
 <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginTop:14}}>
 <div><div style={{fontSize:11,color:C.cyan,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Steps</div>{p.steps.map((s,i)=>(<div key={i} style={{display:"flex",gap:10,marginBottom:8,alignItems:"flex-start"}}><div style={{width:20,height:20,borderRadius:"50%",background:C.accent+"20",border:"1px solid "+C.accent+"40",color:C.accent,fontSize:10,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,flexShrink:0}}>{i+1}</div><div style={{fontSize:12,color:C.sub,lineHeight:1.5}}>{s}</div></div>))}</div>
 <div><div style={{fontSize:11,color:C.red,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Non-Negotiable Rules</div>{p.rules.map((r,i)=>(<div key={i} style={{background:C.red+"10",border:"1px solid "+C.red+"25",borderRadius:8,padding:"7px 12px",marginBottom:6,fontSize:12,color:C.sub}}> {r}</div>))}</div>
 </div>
 </div>)}
 </div>))}
 </div>
 );
}

// --- ROLE MATCHING ------------------------------------------------------------
function RoleMatching({ candidates }) {
 const [query, setQuery] = useState("");
 const [results, setResults] = useState([]);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");

 async function match() {
 if (!query.trim() || !candidates.length) return;
 setLoading(true); setResults([]); setError("");
 try {
 const candidateList = candidates.map((c, idx) => ({ idx, name: c.name, title: c.currentTitle, exp: c.totalYearsExp, skills: (c.skills||[]).slice(0,10).join(", "), tools: (c.tools||[]).slice(0,8).join(", "), departments: (c.departments||[]).join(", "), seniority: c.seniority }));
 const prompt = `You are an expert HR recruiter at Acture Media.\n\nJob Requirement: "${query}"\n\nCandidate Pool:\n${candidateList.map(c=>`[${c.idx}] ${c.name} | ${c.title} | ${c.exp} years | ${c.departments} | Skills: ${c.skills} | Tools: ${c.tools} | ${c.seniority}`).join("\n")}\n\nReturn ONLY a raw JSON array, no markdown:\n[{"idx": 0, "matchScore": 85, "reason": "Strong SEO skills"}]\nSort by matchScore descending. Include all candidates.`;
 const raw = await callClaude([{ role: "user", content: prompt }], "You are a JSON-only response bot. Never use markdown. Always return raw JSON arrays only.");
 let parsed = null;
 try { parsed = JSON.parse(raw.trim()); } catch {}
 if (!parsed) { try { parsed = JSON.parse(raw.replace(/```json\s*/gi,"").replace(/```\s*/gi,"").trim()); } catch {} }
 if (!parsed) { try { const m=raw.match(/\[[\s\S]*\]/); if(m) parsed=JSON.parse(m[0]); } catch {} }
 if (!Array.isArray(parsed)||!parsed.length) { setError("AI returned no results. Try rephrasing."); setLoading(false); return; }
 const enriched = parsed.map(m=>{ const c=candidates[Number(m.idx)]; if(!c) return null; return {...c,matchScore:Math.min(100,Math.max(0,Number(m.matchScore)||0)),matchReason:m.reason||""}; }).filter(Boolean).sort((a,b)=>b.matchScore-a.matchScore).slice(0,10);
 if (!enriched.length) setError("No valid candidates returned. Try again.");
 else setResults(enriched);
 } catch(err) { setError("Matching failed: "+err.message); }
 setLoading(false);
 }
 return (
 <div>
 <h2 style={{fontSize:30,fontWeight:800,color:C.text,margin:"0 0 8px"}}>AI Role Matching Engine</h2>
 <p style={{fontSize:14,color:C.muted,margin:"0 0 20px"}}>Describe a role → AI scans your full talent pool → ranks by match %</p>
 <div style={{background:C.card,border:"1px solid "+C.border,borderRadius:14,padding:22,marginBottom:16}}>
 <textarea value={query} onChange={e=>setQuery(e.target.value)} placeholder="e.g. SEO Executive, 2-4 years, Shopify + WordPress, agency background preferred" rows={3} style={{width:"100%",background:C.surface,border:"1px solid "+C.border,borderRadius:8,padding:"10px 14px",color:C.text,fontSize:13,outline:"none",resize:"vertical",fontFamily:"'Poppins', sans-serif",boxSizing:"border-box"}}/>
 <div style={{marginTop:14,display:"flex",gap:12,alignItems:"center"}}>
 <button onClick={match} disabled={!query.trim()||!candidates.length||loading} style={{background:loading||!query.trim()||!candidates.length?C.surface:C.accent,color:loading||!query.trim()||!candidates.length?C.muted:"#fff",border:"none",borderRadius:8,padding:"10px 22px",fontSize:13,fontWeight:700,cursor:loading||!query.trim()||!candidates.length?"not-allowed":"pointer",opacity:!query.trim()||!candidates.length?0.5:1,fontFamily:"'Poppins', sans-serif"}}>
 {loading?" Matching...":"o Find Best Matches"}
 </button>
 {!candidates.length&&<span style={{fontSize:12,color:C.gold}}> Upload candidates first</span>}
 {candidates.length>0&&!loading&&<span style={{fontSize:12,color:C.muted}}>Scanning {candidates.length} candidates</span>}
 </div>
 </div>
 {error&&!loading&&<div style={{background:C.red+"15",border:"1px solid "+C.red+"40",borderRadius:12,padding:"14px 18px",marginBottom:16,color:"#fca5a5",fontSize:13}}> {error}</div>}
 {!loading&&results.length>0&&(
 <div>
 <div style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:14}}>Top {results.length} Matches</div>
 {results.map((c,i)=>{
 const col=C.accent;
 return (<div key={c.id||i} style={{background:C.card,border:"1px solid "+(i===0?col+"60":C.border),borderRadius:14,padding:20,marginBottom:12,borderLeft:"4px solid "+col,position:"relative"}}>
 {i===0&&<div style={{position:"absolute",top:-1,right:16,background:col,color:"#000",fontSize:10,fontWeight:800,padding:"2px 10px",borderRadius:"0 0 8px 8px",fontFamily:"'Poppins', sans-serif"}}>BEST MATCH</div>}
 <div style={{display:"flex",gap:16,alignItems:"flex-start"}}>
 <div style={{width:40,height:40,borderRadius:10,background:col+"20",border:"1px solid "+col+"40",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:800,color:col,flexShrink:0}}>#{i+1}</div>
 <div style={{flex:1}}>
 <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
 <div><div style={{fontSize:15,fontWeight:700,color:C.text}}>{c.name}</div><div style={{fontSize:12,color:C.sub,marginTop:2}}>{c.currentTitle} · {c.totalYearsExp}y · {c.seniority}</div></div>
 <div style={{display:"flex",gap:8}}><div style={{background:col+"20",color:col,border:"1px solid "+col+"50",borderRadius:8,padding:"5px 14px",fontSize:14,fontWeight:800}}>{c.matchScore}% match</div><ScoreBadge score={getDisplayScore(c)} jdBased={c.jdFitScore!=null}/></div>
 </div>
 <div style={{background:col+"10",border:"1px solid "+col+"25",borderRadius:8,padding:"8px 12px",marginBottom:10,fontSize:12,color:C.sub}}> {c.matchReason}</div>
 <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
 {c.departments?.slice(0,2).map(d=><span key={d} style={{background:C.purple+"18",color:C.purple,border:"1px solid "+C.purple+"35",borderRadius:5,padding:"2px 7px",fontSize:11}}>{d}</span>)}
 {c.skills?.slice(0,5).map(s=><span key={s} style={{background:C.accent+"15",color:C.accent,border:"1px solid "+C.accent+"30",borderRadius:5,padding:"2px 7px",fontSize:11}}>{s}</span>)}
 </div>
 </div>
 </div>
 </div>);
 })}
 </div>
 )}
 </div>
 );
}

// ===============================================================================
// --- APP ROOT -----------------------------------------------------------------
// ===============================================================================
export default function App() {
 const location = useLocation();
 const isHRRoute = location.pathname === "/hr" || location.pathname === "/hr/";
 const [hrAuthed, setHrAuthed] = useState(() => sessionStorage.getItem("hr_auth") === "true");
 const [currentUser, setCurrentUser] = useState(() => {
 try { return JSON.parse(sessionStorage.getItem("hr_user")||"null"); } catch { return null; }
 });

 const [tab, setTab] = useState("dashboard");
 const [candidates, setCandidates] = useState([]);
 const [jobs, setJobs] = useState([]);
 const [jdDocs, setJdDocs] = useState([]);
 const [feedbacks, setFeedbacks] = useState([]);
 const [loaded, setLoaded] = useState(false);
 const [toast, setToast] = useState(null);

 function showToast(msg, type = "success") { setToast({ msg, type, key: Date.now() }); }
 function handleLogout() { sessionStorage.removeItem("hr_auth"); sessionStorage.removeItem("hr_user"); setHrAuthed(false); setCurrentUser(null); }

 useEffect(() => {
 if (!isHRRoute || !hrAuthed) return;
 (async () => {
 const [c, j, jd, fb] = await Promise.all([
 dbGetAll("candidates","acture_candidates"),
 dbGetAll("jobs","acture_jobs"),
 dbGetAll("jd_documents","acture_jds"),
 dbGetAll("feedbacks","acture_feedbacks"),
 ]);
 setCandidates(c); setJobs(j); setJdDocs(jd); setFeedbacks(fb); setLoaded(true);
 })();
 }, [isHRRoute, hrAuthed]);

 if (!isHRRoute) return <CandidatePortal />;
 if (!hrAuthed) return <HRLogin onLogin={(user) => { setHrAuthed(true); setCurrentUser(user); }} />;

 if (!loaded) return (
 <div style={{ background:C.bg, minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Poppins', sans-serif" }}>
 <div style={{ textAlign:"center" }}>
 <ActureLogo size={60}/>
 <div style={{ color:C.text, fontSize:16, marginTop:16 }}>Loading HR Intelligence...</div>
 <div style={{ color:C.muted, fontSize:13, marginTop:8 }}>Connecting to Acture Media database</div>
 </div>
 </div>
 );

 const badges = { dashboard:0, upload:0, pool:candidates.length, hrf:jobs.filter(j=>j.status==="Active").length, jd:jdDocs.length, excel:0, feedback:feedbacks.length, pipeline:0, matching:0 };

 return (
 // *** CHANGE 3: fontFamily updated to Poppins ***
 <div style={{ background:C.bg, minHeight:"100vh", fontFamily:"'Poppins', sans-serif" }}>
 <style>{`
 @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');
 *{box-sizing:border-box;}
 body{font-family:'Poppins', sans-serif;}
 select{appearance:auto;}
 ::-webkit-scrollbar{width:6px;}
 ::-webkit-scrollbar-track{background:${C.bg};}
 ::-webkit-scrollbar-thumb{background:${C.border};border-radius:3px;}
 button:hover:not(:disabled){filter:brightness(0.95);}
 `}</style>
 <Nav tab={tab} setTab={setTab} badges={badges} onLogout={handleLogout} currentUser={currentUser}/>
 <div style={{ paddingTop:70, padding:"80px 36px 60px", maxWidth:1440, margin:"0 auto" }}>
 {tab==="dashboard" && <Dashboard candidates={candidates} jobs={jobs} jdDocs={jdDocs} feedbacks={feedbacks} setTab={setTab} currentUser={currentUser}/>}
 {tab==="upload" && <UploadResume candidates={candidates} setCandidates={setCandidates} showToast={showToast} jdDocs={jdDocs} currentUser={currentUser}/>}
 {tab==="pool" && <TalentPool candidates={candidates} setCandidates={setCandidates} showToast={showToast}/>}
 {tab==="hrf" && <Requisitions jobs={jobs} setJobs={setJobs} showToast={showToast} currentUser={currentUser}/>}
 {tab==="jd" && <JDBuilder jdDocs={jdDocs} setJdDocs={setJdDocs} showToast={showToast}/>}
 {tab==="excel" && <ExcelManager candidates={candidates} showToast={showToast}/>}
 {tab==="feedback" && <InterviewFeedback candidates={candidates} feedbacks={feedbacks} setFeedbacks={setFeedbacks} showToast={showToast}/>}
 {tab==="pipeline" && <SOPPipeline candidates={candidates}/>}
 {tab==="matching" && <RoleMatching candidates={candidates}/>}
 </div>
 {toast && <Toast key={toast.key} msg={toast.msg} type={toast.type} onClose={()=>setToast(null)}/>}
 </div>
 );
}